/*
<auto-generated>
This code was generated from DaBNet.Kamu.Services.DB.CodeGenUI at 01/06/2026
</auto-generated>
*/


export class BysBelge {
Ada?:number;
AnahtarKelime?:string;
ArsivTarih?:Date;
AsliAlindiEh:string;
BarkodNo?:string;
BeklenenDonusTarih?:Date;
BelediyeKod:number;
BelgeAciklama?:string;
BelgeAdi?:string;
BelgeIcerikKod?:number;
BelgeNitelikTuru?:number;
BelgeNo?:string;
BelgeOnemDerece?:string;
BelgeTarih?:Date;
BelgeTuru:string;
BelgeTuruKod:number;
BilgiAdSoyad?:string;
BilgiAdres?:string; // DKM-5507 Cedric: BYS_BELGE.BILGI_ADRES
BilgiEdinmeEh:string;
BilgiEPosta?:string;
BilgiTelNo?:string;
BilgiUnvani?:string;
BirimKod:number;
DagitimSekli:string;
DegisKullaniciKod?:number;
DegisTarih?:Date;
DilekceEh?:string;
DilKod:number;
DosyaPlanKod:string;
EMail?:string;
EskiKisiKod?:number;
EvrakNo?:number;
EvrakTarih?:Date;
EvrakTuru?:string;
GecerliSure?:number;
GelenBirimAciklama?:string;
GelenBirimKod?:number;
GelenGiden?:string;
GelisTurKod?:number;
GenelArsivKod?:number;
GenelDosyaNo?:number;
GonderAlTarih?:Date;
GsmTelefonNo?:string;
GuvenlikDurumu:number;
ImhaTarih?:Date;
ImzaPersonelKod?:number;
KayitKullaniciKod:number;
KayitTarih:Date;
KelimeIslemci?:string;
KisiKod?:number;
KisiselEh:string;
KlasorKod?:number;
Kod:number;
KoordinasyonBirimKod?:number;
OncelikDurumu:string;
OzelNo?:string;
Pafta?:string;
Parsel?:number;
ParselKod?:number;
PersonelKod?:number;
ReferansKod:number;
Statusu?:number;
SurecKod?:number;
TaslakKod?:number;
TcknNo?:number;
TelifKapsamindaEh:string;
TransferTarih?:Date;
UretimAciklama?:string;
UretimTarih?:Date;
YazilimVersion?:string;
YeniEditor?:number;
ZimmetNo?:number;
ZimmetTarih?:Date;
AksParsel?:BysAksParsel;
BysBelgeCaprazDosyas:BysBelgeCaprazDosya[];
BysBelgeDagitims:BysBelgeDagitim[];
BysBelgeDetay:BysBelgeDetay;
BysBelgeEks:BysBelgeEk[];
BysBelgeGonderims:BysBelgeGonderim[];
BysBelgeHavales:BysBelgeHavale[];
BysBelgeIcerik:BysBelgeIcerik;
BysBelgeIlgis:BysBelgeIlgi[];
BysBelgeNots:BysBelgeNot[];
BysBelgeParsels:BysBelgeParsel[];
BysBelgeRapor:BysBelgeRapor;
BysBelgeTakips:BysBelgeTakip[];
BysDegisens:BysDegisen[];
BysEvraks:BysEvrak[];
BysGorevs:BysGorev[];
BysKepKayitlars:BysKepKayitlar[];
BysUetsGelens:BysUetsGelen[];
GasDosya?:BysGasDosya;
GasDosyaBelges:BysGasDosyaBelge[];
GenBelgeTuru:BysGenBelgeTuru;
GenBirim:BysGenBirim;
GenBirim_?:BysGenBirim;
GenBirim1?:BysGenBirim;
GenKisi?:BysGenKisi;
GenKisiEski?:BysGenKisi;
GenKodDetay:BysGenKodDetay;
GenKodDetay1?:BysGenKodDetay;
GenKodDetay2?:BysGenKodDetay;
GysIcraBelges:BysGysIcraBelge[];
GysIcraBelges1:BysGysIcraBelge[];
IkaPersonel?:BysIkaPersonel;
YisKarars:BysYisKarar[];
GenDosyaPlan:BysGenDosyaPlan;

constructor(item?:any){
this.Ada=item?.Ada;
this.AnahtarKelime=item?.AnahtarKelime;
this.ArsivTarih=item?.ArsivTarih;
this.AsliAlindiEh=item?.AsliAlindiEh||'';
this.BarkodNo=item?.BarkodNo;
this.BeklenenDonusTarih=item?.BeklenenDonusTarih;
this.BelediyeKod=item?.BelediyeKod||0;
this.BelgeAciklama=item?.BelgeAciklama;
this.BelgeAdi=item?.BelgeAdi;
this.BelgeIcerikKod=item?.BelgeIcerikKod;
this.BelgeNitelikTuru=item?.BelgeNitelikTuru;
this.BelgeNo=item?.BelgeNo;
this.BelgeOnemDerece=item?.BelgeOnemDerece;
this.BelgeTarih=item?.BelgeTarih;
this.BelgeTuru=item?.BelgeTuru||'';
this.BelgeTuruKod=item?.BelgeTuruKod||0;
this.BilgiAdSoyad=item?.BilgiAdSoyad;
this.BilgiAdres=item?.BilgiAdres; // DKM-5507 Cedric
this.BilgiEdinmeEh=item?.BilgiEdinmeEh||'';
this.BilgiEPosta=item?.BilgiEPosta;
this.BilgiTelNo=item?.BilgiTelNo;
this.BilgiUnvani=item?.BilgiUnvani;
this.BirimKod=item?.BirimKod||0;
this.DagitimSekli=item?.DagitimSekli||'';
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.DilekceEh=item?.DilekceEh;
this.DilKod=item?.DilKod||0;
this.DosyaPlanKod=item?.DosyaPlanKod||'';
this.EMail=item?.EMail;
this.EskiKisiKod=item?.EskiKisiKod;
this.EvrakNo=item?.EvrakNo;
this.EvrakTarih=item?.EvrakTarih;
this.EvrakTuru=item?.EvrakTuru;
this.GecerliSure=item?.GecerliSure;
this.GelenBirimAciklama=item?.GelenBirimAciklama;
this.GelenBirimKod=item?.GelenBirimKod;
this.GelenGiden=item?.GelenGiden;
this.GelisTurKod=item?.GelisTurKod;
this.GenelArsivKod=item?.GenelArsivKod;
this.GenelDosyaNo=item?.GenelDosyaNo;
this.GonderAlTarih=item?.GonderAlTarih;
this.GsmTelefonNo=item?.GsmTelefonNo;
this.GuvenlikDurumu=item?.GuvenlikDurumu||0;
this.ImhaTarih=item?.ImhaTarih;
this.ImzaPersonelKod=item?.ImzaPersonelKod;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.KelimeIslemci=item?.KelimeIslemci;
this.KisiKod=item?.KisiKod;
this.KisiselEh=item?.KisiselEh||'';
this.KlasorKod=item?.KlasorKod;
this.Kod=item?.Kod||0;
this.KoordinasyonBirimKod=item?.KoordinasyonBirimKod;
this.OncelikDurumu=item?.OncelikDurumu||'';
this.OzelNo=item?.OzelNo;
this.Pafta=item?.Pafta;
this.Parsel=item?.Parsel;
this.ParselKod=item?.ParselKod;
this.PersonelKod=item?.PersonelKod;
this.ReferansKod=item?.ReferansKod||0;
this.Statusu=item?.Statusu;
this.SurecKod=item?.SurecKod;
this.TaslakKod=item?.TaslakKod;
this.TcknNo=item?.TcknNo;
this.TelifKapsamindaEh=item?.TelifKapsamindaEh||'';
this.TransferTarih=item?.TransferTarih;
this.UretimAciklama=item?.UretimAciklama;
this.UretimTarih=item?.UretimTarih;
this.YazilimVersion=item?.YazilimVersion;
this.YeniEditor=item?.YeniEditor;
this.ZimmetNo=item?.ZimmetNo;
this.ZimmetTarih=item?.ZimmetTarih;
this.AksParsel=item?.AksParsel;
this.BysBelgeCaprazDosyas=item?.BysBelgeCaprazDosyas;
this.BysBelgeDagitims=item?.BysBelgeDagitims;
this.BysBelgeDetay=item?.BysBelgeDetay;
this.BysBelgeEks=item?.BysBelgeEks;
this.BysBelgeGonderims=item?.BysBelgeGonderims;
this.BysBelgeHavales=item?.BysBelgeHavales;
this.BysBelgeIcerik=item?.BysBelgeIcerik;
this.BysBelgeIlgis=item?.BysBelgeIlgis;
this.BysBelgeNots=item?.BysBelgeNots;
this.BysBelgeParsels=item?.BysBelgeParsels;
this.BysBelgeRapor=item?.BysBelgeRapor;
this.BysBelgeTakips=item?.BysBelgeTakips;
this.BysDegisens=item?.BysDegisens;
this.BysEvraks=item?.BysEvraks;
this.BysGorevs=item?.BysGorevs;
this.BysKepKayitlars=item?.BysKepKayitlars;
this.BysUetsGelens=item?.BysUetsGelens;
this.GasDosya=item?.GasDosya;
this.GasDosyaBelges=item?.GasDosyaBelges;
this.GenBelgeTuru=item?.GenBelgeTuru;
this.GenBirim=item?.GenBirim;
this.GenBirim_=item?.GenBirim_;
this.GenBirim1=item?.GenBirim1;
this.GenKisi=item?.GenKisi;
this.GenKisiEski=item?.GenKisiEski;
this.GenKodDetay=item?.GenKodDetay;
this.GenKodDetay1=item?.GenKodDetay1;
this.GenKodDetay2=item?.GenKodDetay2;
this.GysIcraBelges=item?.GysIcraBelges;
this.GysIcraBelges1=item?.GysIcraBelges1;
this.IkaPersonel=item?.IkaPersonel;
this.YisKarars=item?.YisKarars;
this.GenDosyaPlan=item?.GenDosyaPlan;
}
}

export class BysBelgeCaprazDosya {
BelediyeKod:number;
BelgeAciklama?:string;
BelgeKod:number;
BelgeTuruKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
DosyaPlanKod:string;
GenelArsivKod?:number;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
BysBelge:BysBelge;
GasDosya?:BysGasDosya;
GenBelgeTuru:BysGenBelgeTuru;
GenDosyaPlan:BysGenDosyaPlan;

constructor(item?:any){
this.BelediyeKod=item?.BelediyeKod||0;
this.BelgeAciklama=item?.BelgeAciklama;
this.BelgeKod=item?.BelgeKod||0;
this.BelgeTuruKod=item?.BelgeTuruKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.DosyaPlanKod=item?.DosyaPlanKod||'';
this.GenelArsivKod=item?.GenelArsivKod;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.BysBelge=item?.BysBelge;
this.GasDosya=item?.GasDosya;
this.GenBelgeTuru=item?.GenBelgeTuru;
this.GenDosyaPlan=item?.GenDosyaPlan;
}
}

export class BysBelgeDagitim {
Aciklama?:string;
BelgeKod:number;
BirimAciklama?:string;
BirimKimlikNo?:string;
BirimKod:number;
BirimTuru?:string;
DagitimSekli:string;
DegisKullaniciKod?:number;
DegisTarih?:Date;
Eposta?:string;
GonderimAdres?:string;
GonderimBedeli?:number;
GonderimDurum?:string;
GonderimNot?:string;
GonderimTarih?:Date;
GonderimTipi?:string;
IslemTuru:string;
KayitKullaniciKod:number;
KayitTarih:Date;
KepAdres?:string;
KepDurum?:string;
KepId?:number;
KisiKod?:number;
Kod:number;
PostaTuruKod?:number;
PostaUcret?:number;
RedAdedi?:number;
RedNedeni?:string;
Sira?:number;
Telefon?:string;
UstBirimKod?:number;
BysBelge:BysBelge;
BysBelgeGonderims:BysBelgeGonderim[];
BysEvraks:BysEvrak[];
GenBirim:BysGenBirim;
GenBirimUst?:BysGenBirim;

constructor(item?:any){
this.Aciklama=item?.Aciklama;
this.BelgeKod=item?.BelgeKod||0;
this.BirimAciklama=item?.BirimAciklama;
this.BirimKimlikNo=item?.BirimKimlikNo;
this.BirimKod=item?.BirimKod||0;
this.BirimTuru=item?.BirimTuru;
this.DagitimSekli=item?.DagitimSekli||'';
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.Eposta=item?.Eposta;
this.GonderimAdres=item?.GonderimAdres;
this.GonderimBedeli=item?.GonderimBedeli;
this.GonderimDurum=item?.GonderimDurum;
this.GonderimNot=item?.GonderimNot;
this.GonderimTarih=item?.GonderimTarih;
this.GonderimTipi=item?.GonderimTipi;
this.IslemTuru=item?.IslemTuru||'';
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.KepAdres=item?.KepAdres;
this.KepDurum=item?.KepDurum;
this.KepId=item?.KepId;
this.KisiKod=item?.KisiKod;
this.Kod=item?.Kod||0;
this.PostaTuruKod=item?.PostaTuruKod;
this.PostaUcret=item?.PostaUcret;
this.RedAdedi=item?.RedAdedi;
this.RedNedeni=item?.RedNedeni;
this.Sira=item?.Sira;
this.Telefon=item?.Telefon;
this.UstBirimKod=item?.UstBirimKod;
this.BysBelge=item?.BysBelge;
this.BysBelgeGonderims=item?.BysBelgeGonderims;
this.BysEvraks=item?.BysEvraks;
this.GenBirim=item?.GenBirim;
this.GenBirimUst=item?.GenBirimUst;
}
}

export class BysBelgeDetay {
BelgeAd?:string;
BelgeDysKod?:string;
BelgeKod:number;
BelgePath?:string;
BelgeTipKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
DogrulamaKodu?:string;
EimzaBelgeAd?:string;
EimzaBelgeDysKod?:string;
EimzaBelgeTipKod?:number;
EypDysId?:string;
EypStatus?:number;
IcerikGuncelEh?:string;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
YaziciBelgeDysKod?:string;
BysBelge:BysBelge;
GenBelgeTip:BysGenBelgeTip;
GenBelgeTip1?:BysGenBelgeTip;

constructor(item?:any){
this.BelgeAd=item?.BelgeAd;
this.BelgeDysKod=item?.BelgeDysKod;
this.BelgeKod=item?.BelgeKod||0;
this.BelgePath=item?.BelgePath;
this.BelgeTipKod=item?.BelgeTipKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.DogrulamaKodu=item?.DogrulamaKodu;
this.EimzaBelgeAd=item?.EimzaBelgeAd;
this.EimzaBelgeDysKod=item?.EimzaBelgeDysKod;
this.EimzaBelgeTipKod=item?.EimzaBelgeTipKod;
this.EypDysId=item?.EypDysId;
this.EypStatus=item?.EypStatus;
this.IcerikGuncelEh=item?.IcerikGuncelEh;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.YaziciBelgeDysKod=item?.YaziciBelgeDysKod;
this.BysBelge=item?.BysBelge;
this.GenBelgeTip=item?.GenBelgeTip;
this.GenBelgeTip1=item?.GenBelgeTip1;
}
}

export class BysBelgeEk {
AdetSayfa?:string;
BelediyeKod:number;
BelgeAciklama?:string;
BelgeAd?:string;
BelgeDysKod?:string;
BelgeKod:number;
BelgeNo?:number;
BelgePath?:string;
BelgeTarih?:Date;
BelgeTipKod?:number;
BelgeTuruKod?:number;
Boyut?:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
FizikselBelgeEh?:string;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
ReferansKod?:number;
Sira?:number;
BysBelge:BysBelge;
GenBelgeTip?:BysGenBelgeTip;
GenBelgeTuru?:BysGenBelgeTuru;

constructor(item?:any){
this.AdetSayfa=item?.AdetSayfa;
this.BelediyeKod=item?.BelediyeKod||0;
this.BelgeAciklama=item?.BelgeAciklama;
this.BelgeAd=item?.BelgeAd;
this.BelgeDysKod=item?.BelgeDysKod;
this.BelgeKod=item?.BelgeKod||0;
this.BelgeNo=item?.BelgeNo;
this.BelgePath=item?.BelgePath;
this.BelgeTarih=item?.BelgeTarih;
this.BelgeTipKod=item?.BelgeTipKod;
this.BelgeTuruKod=item?.BelgeTuruKod;
this.Boyut=item?.Boyut;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.FizikselBelgeEh=item?.FizikselBelgeEh;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.ReferansKod=item?.ReferansKod;
this.Sira=item?.Sira;
this.BysBelge=item?.BysBelge;
this.GenBelgeTip=item?.GenBelgeTip;
this.GenBelgeTuru=item?.GenBelgeTuru;
}
}

export class BysBelgeGonderim {
Aciklama?:string;
BelgeKod:number;
BirimKod:number;
DagitimKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
GonderimAdres?:string;
GonderimBedeli?:number;
GonderimDurum?:string;
GonderimNot?:string;
GonderimTarih?:Date;
GonderimTipi?:string;
KayitKullaniciKod:number;
KayitTarih:Date;
KepAdres?:string;
KepDurum?:string;
KepId?:number;
Kod:number;
PostaTuruKod?:number;
PostaUcret?:number;
BysBelge:BysBelge;
BysBelgeDagitim:BysBelgeDagitim;
GenBirim:BysGenBirim;

constructor(item?:any){
this.Aciklama=item?.Aciklama;
this.BelgeKod=item?.BelgeKod||0;
this.BirimKod=item?.BirimKod||0;
this.DagitimKod=item?.DagitimKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.GonderimAdres=item?.GonderimAdres;
this.GonderimBedeli=item?.GonderimBedeli;
this.GonderimDurum=item?.GonderimDurum;
this.GonderimNot=item?.GonderimNot;
this.GonderimTarih=item?.GonderimTarih;
this.GonderimTipi=item?.GonderimTipi;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.KepAdres=item?.KepAdres;
this.KepDurum=item?.KepDurum;
this.KepId=item?.KepId;
this.Kod=item?.Kod||0;
this.PostaTuruKod=item?.PostaTuruKod;
this.PostaUcret=item?.PostaUcret;
this.BysBelge=item?.BysBelge;
this.BysBelgeDagitim=item?.BysBelgeDagitim;
this.GenBirim=item?.GenBirim;
}
}

export class BysBelgeHavale {
BelediyeKod:number;
BelgeKod:number;
BirimKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
EvrakKod?:number;
HavaleAciklama?:string;
HavaleTarih:Date;
HavaleTipi?:string;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
PersonelKod:number;
SonucAciklama?:string;
SonucTarih?:Date;
SonucTurKod?:number;
BysBelge:BysBelge;
BysEvrak?:BysEvrak;
GenBirim:BysGenBirim;
IkaPersonel:BysIkaPersonel;

constructor(item?:any){
this.BelediyeKod=item?.BelediyeKod||0;
this.BelgeKod=item?.BelgeKod||0;
this.BirimKod=item?.BirimKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.EvrakKod=item?.EvrakKod;
this.HavaleAciklama=item?.HavaleAciklama;
this.HavaleTarih=item?.HavaleTarih||new Date();
this.HavaleTipi=item?.HavaleTipi;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.PersonelKod=item?.PersonelKod||0;
this.SonucAciklama=item?.SonucAciklama;
this.SonucTarih=item?.SonucTarih;
this.SonucTurKod=item?.SonucTurKod;
this.BysBelge=item?.BysBelge;
this.BysEvrak=item?.BysEvrak;
this.GenBirim=item?.GenBirim;
this.IkaPersonel=item?.IkaPersonel;
}
}

export class BysBelgeIcerik {
BelgeIcerik?:string;
BelgeKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
BysBelge:BysBelge;

constructor(item?:any){
this.BelgeIcerik=item?.BelgeIcerik;
this.BelgeKod=item?.BelgeKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.BysBelge=item?.BysBelge;
}
}

export class BysBelgeIlgi {
BelediyeKod:number;
BelgeKod:number;
BirimKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
EvrakNo?:number;
EvrakTarih?:Date;
IlgiAciklama?:string;
IlgiTuru:string;
IlgiYonu?:string; // DKM-5048 Clara: BYS_BELGE_ILGI.ILGI_YONU (G = gelen yazı, I = kendi giden yazımız)
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
ReferansKod?:number;
Sira?:number;
SmsEh?:string;
BysBelge:BysBelge;
GenBirim:BysGenBirim;
RefBysBelge:BysBelge;

constructor(item?:any){
this.BelediyeKod=item?.BelediyeKod||0;
this.BelgeKod=item?.BelgeKod||0;
this.BirimKod=item?.BirimKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.EvrakNo=item?.EvrakNo;
this.EvrakTarih=item?.EvrakTarih;
this.IlgiAciklama=item?.IlgiAciklama;
this.IlgiTuru=item?.IlgiTuru||'';
this.IlgiYonu=item?.IlgiYonu; // DKM-5048 Clara
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.ReferansKod=item?.ReferansKod;
this.Sira=item?.Sira;
this.SmsEh=item?.SmsEh;
this.BysBelge=item?.BysBelge;
this.GenBirim=item?.GenBirim;
this.RefBysBelge=item?.RefBysBelge;
}
}

export class BysBelgeLog {
Aciklama?:string;
BelgeKod:number;
DagitimKod?:number;
Durum?:number;
EvrakKod?:number;
Hata?:string;
Ip?:string;
IslemAd:string;
Kod:number;
KullaniciAd?:string;
KullaniciKod:number;
LogTarih:Date;

constructor(item?:any){
this.Aciklama=item?.Aciklama;
this.BelgeKod=item?.BelgeKod||0;
this.DagitimKod=item?.DagitimKod;
this.Durum=item?.Durum;
this.EvrakKod=item?.EvrakKod;
this.Hata=item?.Hata;
this.Ip=item?.Ip;
this.IslemAd=item?.IslemAd||'';
this.Kod=item?.Kod||0;
this.KullaniciAd=item?.KullaniciAd;
this.KullaniciKod=item?.KullaniciKod||0;
this.LogTarih=item?.LogTarih||new Date();
}
}

export class BysBelgeNot {
BelgeKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
KullaniciEh:string;
Note:string;
BysBelge:BysBelge;

constructor(item?:any){
this.BelgeKod=item?.BelgeKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.KullaniciEh=item?.KullaniciEh||'';
this.Note=item?.Note||'';
this.BysBelge=item?.BysBelge;
}
}

export class BysBelgeParsel {
Ada:number;
BelgeKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
Pafta?:string;
Parsel:number;
ParselKod?:number;
AksParsel?:BysAksParsel;
BysBelge:BysBelge;

constructor(item?:any){
this.Ada=item?.Ada||0;
this.BelgeKod=item?.BelgeKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.Pafta=item?.Pafta;
this.Parsel=item?.Parsel||0;
this.ParselKod=item?.ParselKod;
this.AksParsel=item?.AksParsel;
this.BysBelge=item?.BysBelge;
}
}

export class BysBelgeRapor {
AltReferansKod?:number;
AltTabloAdi?:string;
BelgeKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
RaporAdi:string;
ReferansKod?:number;
TabloAdi?:string;
BysBelge:BysBelge;

constructor(item?:any){
this.AltReferansKod=item?.AltReferansKod;
this.AltTabloAdi=item?.AltTabloAdi;
this.BelgeKod=item?.BelgeKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.RaporAdi=item?.RaporAdi||'';
this.ReferansKod=item?.ReferansKod;
this.TabloAdi=item?.TabloAdi;
this.BysBelge=item?.BysBelge;
}
}

export class BysBelgeTakip {
BelgeAtamaEh?:string;
BelgeKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
KullaniciKlasorKod?:number;
KullaniciKod:number;
BysBelge:BysBelge;
BysKullaniciKlasor?:BysKullaniciKlasor;

constructor(item?:any){
this.BelgeAtamaEh=item?.BelgeAtamaEh;
this.BelgeKod=item?.BelgeKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.KullaniciKlasorKod=item?.KullaniciKlasorKod;
this.KullaniciKod=item?.KullaniciKod||0;
this.BysBelge=item?.BysBelge;
this.BysKullaniciKlasor=item?.BysKullaniciKlasor;
}
}

export class BysBelgeTarama {
DosyaAd?:string;
DosyaPath?:string;
Kod:number;
TabloAdi:string;
TabloKod?:number;

constructor(item?:any){
this.DosyaAd=item?.DosyaAd;
this.DosyaPath=item?.DosyaPath;
this.Kod=item?.Kod||0;
this.TabloAdi=item?.TabloAdi||'';
this.TabloKod=item?.TabloKod;
}
}

export class BysBirimKullaniciYetki {
BelediyeKod:number;
BirimEvrakSorgulaEh?:string;
BirimKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
EvrakKabulEh?:string;
GuvenlikDurumu:number;
KalemEh:string;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
KullaniciKod:number;
MailEh?:string;
ServisKod?:number;
SmsEh?:string;
GenBirim:BysGenBirim;
GenBirimIletisim?:BysGenBirimIletisim;
GenKullanici:BysGenKullanici;

constructor(item?:any){
this.BelediyeKod=item?.BelediyeKod||0;
this.BirimEvrakSorgulaEh=item?.BirimEvrakSorgulaEh;
this.BirimKod=item?.BirimKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.EvrakKabulEh=item?.EvrakKabulEh;
this.GuvenlikDurumu=item?.GuvenlikDurumu||0;
this.KalemEh=item?.KalemEh||'';
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.KullaniciKod=item?.KullaniciKod||0;
this.MailEh=item?.MailEh;
this.ServisKod=item?.ServisKod;
this.SmsEh=item?.SmsEh;
this.GenBirim=item?.GenBirim;
this.GenBirimIletisim=item?.GenBirimIletisim;
this.GenKullanici=item?.GenKullanici;
}
}

export class BysBirimOtoNumara {
BirimKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
GelenEvrakNo?:number;
GidenEvrakNo?:number;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
Yil:number;
GenBirim:BysGenBirim;

constructor(item?:any){
this.BirimKod=item?.BirimKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.GelenEvrakNo=item?.GelenEvrakNo;
this.GidenEvrakNo=item?.GidenEvrakNo;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.Yil=item?.Yil||0;
this.GenBirim=item?.GenBirim;
}
}

export class BysDagitimBirim {
Aciklama?:string;
BirimKod:number;
DagitimSablonKod:number;
DagitimSekli:string;
DegisKullaniciKod?:number;
DegisTarih?:Date;
IslemTuru:string;
KayitKullaniciKod:number;
KayitTarih:Date;
KepDurum?:string;
Kod:number;

constructor(item?:any){
this.Aciklama=item?.Aciklama;
this.BirimKod=item?.BirimKod||0;
this.DagitimSablonKod=item?.DagitimSablonKod||0;
this.DagitimSekli=item?.DagitimSekli||'';
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.IslemTuru=item?.IslemTuru||'';
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.KepDurum=item?.KepDurum;
this.Kod=item?.Kod||0;
}
}

export class BysDagitimSablon {
AktifEh:string;
BelediyeKod:number;
BirimKod?:number;
DagitimSablonAdi:string;
DegisKullaniciKod?:number;
DegisTarih?:Date;
GelenBelgeEh:string;
GidenBelgeEh:string;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
GenBirim?:BysGenBirim;

constructor(item?:any){
this.AktifEh=item?.AktifEh||'';
this.BelediyeKod=item?.BelediyeKod||0;
this.BirimKod=item?.BirimKod;
this.DagitimSablonAdi=item?.DagitimSablonAdi||'';
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.GelenBelgeEh=item?.GelenBelgeEh||'';
this.GidenBelgeEh=item?.GidenBelgeEh||'';
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.GenBirim=item?.GenBirim;
}
}

export class BysDegisen {
BelediyeKod:number;
BelgeKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
Icerik?:string;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
SurecKod:number;
BysBelge:BysBelge;
BysGorev:BysGorev;

constructor(item?:any){
this.BelediyeKod=item?.BelediyeKod||0;
this.BelgeKod=item?.BelgeKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.Icerik=item?.Icerik;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.SurecKod=item?.SurecKod||0;
this.BysBelge=item?.BysBelge;
this.BysGorev=item?.BysGorev;
}
}

export class BysDosyaPlanKriter {
DegisKullaniciKod?:number;
DegisTarih?:Date;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
PlanKod:number;
SaklamaKriterKod:number;
GenDosyaPlan:BysGenDosyaPlan;
GenKodDetay:BysGenKodDetay;

constructor(item?:any){
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.PlanKod=item?.PlanKod||0;
this.SaklamaKriterKod=item?.SaklamaKriterKod||0;
this.GenDosyaPlan=item?.GenDosyaPlan;
this.GenKodDetay=item?.GenKodDetay;
}
}

export class BysDysSil {
BelgeAd?:string;
DysKod:string;
DysSilTarih?:Date;
Kod:number;
KolonAdi:string;
SilTarih:Date;
TabloAd:string;

constructor(item?:any){
this.BelgeAd=item?.BelgeAd;
this.DysKod=item?.DysKod||'';
this.DysSilTarih=item?.DysSilTarih;
this.Kod=item?.Kod||0;
this.KolonAdi=item?.KolonAdi||'';
this.SilTarih=item?.SilTarih||new Date();
this.TabloAd=item?.TabloAd||'';
}
}

export class BysEvrak {
Aciklama?:string;
BelediyeKod:number;
BelgeKod:number;
BirimKod:number;
BirimNot?:string;
DagitimKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
EvrakNo:number;
EvrakTarih:Date;
EvrakTuru:string;
GelenGiden:string;
GenelArsivKod?:number;
KapatmaAciklama?:string;
KapatmaTarih?:Date;
KapatmaTurKod?:number;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
PostaNot?:string;
TebligNot?:string;
ZimmetNo?:number;
ZimmetTarih?:Date;
BysBelge:BysBelge;
BysBelgeDagitim:BysBelgeDagitim;
BysBelgeHavales:BysBelgeHavale[];
GasDosya?:BysGasDosya;
GenBirim:BysGenBirim;

constructor(item?:any){
this.Aciklama=item?.Aciklama;
this.BelediyeKod=item?.BelediyeKod||0;
this.BelgeKod=item?.BelgeKod||0;
this.BirimKod=item?.BirimKod||0;
this.BirimNot=item?.BirimNot;
this.DagitimKod=item?.DagitimKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.EvrakNo=item?.EvrakNo||0;
this.EvrakTarih=item?.EvrakTarih||new Date();
this.EvrakTuru=item?.EvrakTuru||'';
this.GelenGiden=item?.GelenGiden||'';
this.GenelArsivKod=item?.GenelArsivKod;
this.KapatmaAciklama=item?.KapatmaAciklama;
this.KapatmaTarih=item?.KapatmaTarih;
this.KapatmaTurKod=item?.KapatmaTurKod;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.PostaNot=item?.PostaNot;
this.TebligNot=item?.TebligNot;
this.ZimmetNo=item?.ZimmetNo;
this.ZimmetTarih=item?.ZimmetTarih;
this.BysBelge=item?.BysBelge;
this.BysBelgeDagitim=item?.BysBelgeDagitim;
this.BysBelgeHavales=item?.BysBelgeHavales;
this.GasDosya=item?.GasDosya;
this.GenBirim=item?.GenBirim;
}
}

export class BysGorev {
BaslamaTarih:Date;
BelediyeKod:number;
BelgeKod:number;
BirimKod:number;
BitisTarih?:Date;
DegisKullaniciKod?:number;
DegisTarih?:Date;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
SonucAciklama?:string;
SonucTuru:number;
SurecKod:number;
BysBelge:BysBelge;
BysDegisens:BysDegisen[];
BysGorevDetays:BysGorevDetay[];
BysSurec:BysSurec;
GenBirim:BysGenBirim;

constructor(item?:any){
this.BaslamaTarih=item?.BaslamaTarih||new Date();
this.BelediyeKod=item?.BelediyeKod||0;
this.BelgeKod=item?.BelgeKod||0;
this.BirimKod=item?.BirimKod||0;
this.BitisTarih=item?.BitisTarih;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.SonucAciklama=item?.SonucAciklama;
this.SonucTuru=item?.SonucTuru||0;
this.SurecKod=item?.SurecKod||0;
this.BysBelge=item?.BysBelge;
this.BysDegisens=item?.BysDegisens;
this.BysGorevDetays=item?.BysGorevDetays;
this.BysSurec=item?.BysSurec;
this.GenBirim=item?.GenBirim;
}
}

export class BysGorevDagitim {
AtanacakGorevKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
GorevBaslamaTarih?:Date;
GorevBitisTarih?:Date;
GorevKod:number;
GorevTamamlandiEh:string;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
SurecGorevKod:number;
BysGorevDetay:BysGorevDetay;

constructor(item?:any){
this.AtanacakGorevKod=item?.AtanacakGorevKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.GorevBaslamaTarih=item?.GorevBaslamaTarih;
this.GorevBitisTarih=item?.GorevBitisTarih;
this.GorevKod=item?.GorevKod||0;
this.GorevTamamlandiEh=item?.GorevTamamlandiEh||'';
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.SurecGorevKod=item?.SurecGorevKod||0;
this.BysGorevDetay=item?.BysGorevDetay;
}
}

export class BysGorevDetay {
Aciklama?:string;
AktifGorevEh:string;
BelediyeKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
EskiPersonelKod?:number;
EypImzaEh?:string;
GorevAd:string;
GorevBaslamaTarih?:Date;
GorevBitisTarih?:Date;
GorevKod:number;
GorevSonucTuru?:number;
GorevTamamlandiEh:string;
GorevTuru:number;
ImzaEh:string;
ImzaGorev?:string;
ImzaOnayTuru?:string;
ImzaStatus?:number;
ImzaTuru?:string;
ImzaUnvan?:string;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
MailEh:string;
PersonelKod?:number;
RolAd?:string;
SmsEh:string;
SonrakiGorevKod?:number;
SurecGorevKod:number;
ZamanDamgaEh:string;
BysGorev:BysGorev;
IkaPersonel?:BysIkaPersonel;
GenOrganizasyon:BysGenOrganizasyon;

constructor(item?:any){
this.Aciklama=item?.Aciklama;
this.AktifGorevEh=item?.AktifGorevEh||'';
this.BelediyeKod=item?.BelediyeKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.EskiPersonelKod=item?.EskiPersonelKod;
this.EypImzaEh=item?.EypImzaEh;
this.GorevAd=item?.GorevAd||'';
this.GorevBaslamaTarih=item?.GorevBaslamaTarih;
this.GorevBitisTarih=item?.GorevBitisTarih;
this.GorevKod=item?.GorevKod||0;
this.GorevSonucTuru=item?.GorevSonucTuru;
this.GorevTamamlandiEh=item?.GorevTamamlandiEh||'';
this.GorevTuru=item?.GorevTuru||0;
this.ImzaEh=item?.ImzaEh||'';
this.ImzaGorev=item?.ImzaGorev;
this.ImzaOnayTuru=item?.ImzaOnayTuru;
this.ImzaStatus=item?.ImzaStatus;
this.ImzaTuru=item?.ImzaTuru;
this.ImzaUnvan=item?.ImzaUnvan;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.MailEh=item?.MailEh||'';
this.PersonelKod=item?.PersonelKod;
this.RolAd=item?.RolAd;
this.SmsEh=item?.SmsEh||'';
this.SonrakiGorevKod=item?.SonrakiGorevKod;
this.SurecGorevKod=item?.SurecGorevKod||0;
this.ZamanDamgaEh=item?.ZamanDamgaEh||'';
this.BysGorev=item?.BysGorev;
this.IkaPersonel=item?.IkaPersonel;
this.GenOrganizasyon=item?.GenOrganizasyon;
}
}

export class BysGorevTempDetay {
Aciklama?:string;
BelediyeKod:number;
BelgeKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
GorevAd:string;
GorevKod:number;
GorevTuru:number;
ImzaEh:string;
ImzaGorev?:string;
ImzaTuru?:string;
ImzaUnvan?:string;
IslemKod:string;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
MailEh:string;
PersonelKod?:number;
RolAd?:string;
SmsEh:string;
SonrakiGorevKod?:number;
SurecKod:number;
ZamanDamgaEh:string;

constructor(item?:any){
this.Aciklama=item?.Aciklama;
this.BelediyeKod=item?.BelediyeKod||0;
this.BelgeKod=item?.BelgeKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.GorevAd=item?.GorevAd||'';
this.GorevKod=item?.GorevKod||0;
this.GorevTuru=item?.GorevTuru||0;
this.ImzaEh=item?.ImzaEh||'';
this.ImzaGorev=item?.ImzaGorev;
this.ImzaTuru=item?.ImzaTuru;
this.ImzaUnvan=item?.ImzaUnvan;
this.IslemKod=item?.IslemKod||'';
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.MailEh=item?.MailEh||'';
this.PersonelKod=item?.PersonelKod;
this.RolAd=item?.RolAd;
this.SmsEh=item?.SmsEh||'';
this.SonrakiGorevKod=item?.SonrakiGorevKod;
this.SurecKod=item?.SurecKod||0;
this.ZamanDamgaEh=item?.ZamanDamgaEh||'';
}
}

export class BysKepDeliller {
DegisKullaniciKod?:number;
DegisTarih?:Date;
DelilKodu:number;
DelilKonu?:string;
DelilMesajId?:string;
DelilTarihi?:Date;
DelilTipi?:number;
KayitKullaniciKod:number;
KayitTarih:Date;
KepId?:number;
KepKayitKod?:number;
Kod:number;
BysKepKayitlar?:BysKepKayitlar;

constructor(item?:any){
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.DelilKodu=item?.DelilKodu||0;
this.DelilKonu=item?.DelilKonu;
this.DelilMesajId=item?.DelilMesajId;
this.DelilTarihi=item?.DelilTarihi;
this.DelilTipi=item?.DelilTipi;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.KepId=item?.KepId;
this.KepKayitKod=item?.KepKayitKod;
this.Kod=item?.Kod||0;
this.BysKepKayitlar=item?.BysKepKayitlar;
}
}

export class BysKepEkler {
DegisKullaniciKod?:number;
DegisTarih?:Date;
DosyaAdi:string;
DysId?:string;
EypAcildiEh?:string;
KayitKullaniciKod:number;
KayitTarih:Date;
KepId?:number;
KepKayitKod?:number;
Kod:number;
RefKey?:string;
Sira?:number;
UstKod?:number;
BysKepKayitlar?:BysKepKayitlar;

constructor(item?:any){
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.DosyaAdi=item?.DosyaAdi||'';
this.DysId=item?.DysId;
this.EypAcildiEh=item?.EypAcildiEh;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.KepId=item?.KepId;
this.KepKayitKod=item?.KepKayitKod;
this.Kod=item?.Kod||0;
this.RefKey=item?.RefKey;
this.Sira=item?.Sira;
this.UstKod=item?.UstKod;
this.BysKepKayitlar=item?.BysKepKayitlar;
}
}

export class BysKepKayitlar {
BelediyeKod?:number;
BelgeKod?:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
EvrakAktarildi?:string;
GelenGiden?:string;
KayitKullaniciKod:number;
KayitTarih:Date;
KepCc?:string;
KepEventCode?:string;
KepEvindenceType?:string;
KepFrom?:string;
KepId?:number;
KepIleti?:string;
KepMesajId?:string;
KepMesajType?:string;
KepReceivedDatesPecified?:string;
KepRecevedDate?:Date;
KepSendDate?:Date;
KepSendDateSpecified?:string;
KepSubject?:string;
KepTo?:string;
KepTrgunSayac?:string;
KepTriletiId?:string;
KepTriletiTip?:string;
KepUamessageIdentifier?:string;
Kod:number;
Okundu?:string;
BysBelge?:BysBelge;
BysKepDelillers:BysKepDeliller[];
BysKepEklers:BysKepEkler[];

constructor(item?:any){
this.BelediyeKod=item?.BelediyeKod;
this.BelgeKod=item?.BelgeKod;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.EvrakAktarildi=item?.EvrakAktarildi;
this.GelenGiden=item?.GelenGiden;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.KepCc=item?.KepCc;
this.KepEventCode=item?.KepEventCode;
this.KepEvindenceType=item?.KepEvindenceType;
this.KepFrom=item?.KepFrom;
this.KepId=item?.KepId;
this.KepIleti=item?.KepIleti;
this.KepMesajId=item?.KepMesajId;
this.KepMesajType=item?.KepMesajType;
this.KepReceivedDatesPecified=item?.KepReceivedDatesPecified;
this.KepRecevedDate=item?.KepRecevedDate;
this.KepSendDate=item?.KepSendDate;
this.KepSendDateSpecified=item?.KepSendDateSpecified;
this.KepSubject=item?.KepSubject;
this.KepTo=item?.KepTo;
this.KepTrgunSayac=item?.KepTrgunSayac;
this.KepTriletiId=item?.KepTriletiId;
this.KepTriletiTip=item?.KepTriletiTip;
this.KepUamessageIdentifier=item?.KepUamessageIdentifier;
this.Kod=item?.Kod||0;
this.Okundu=item?.Okundu;
this.BysBelge=item?.BysBelge;
this.BysKepDelillers=item?.BysKepDelillers;
this.BysKepEklers=item?.BysKepEklers;
}
}

export class BysKepTeslimatlar {
Alici?:string;
AliciKabul?:number;
AliciKabulTarih?:Date;
DegisKullaniciKod?:number;
DegisTarih?:Date;
KayitKullaniciKod:number;
KayitTarih:Date;
KepId:number;
KepKabul?:number;
KepKabulTarih?:Date;
Kod:number;
Okundu?:number;
OkunmaTarih?:Date;
Teslim?:number;
TeslimTarih?:Date;

constructor(item?:any){
this.Alici=item?.Alici;
this.AliciKabul=item?.AliciKabul;
this.AliciKabulTarih=item?.AliciKabulTarih;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.KepId=item?.KepId||0;
this.KepKabul=item?.KepKabul;
this.KepKabulTarih=item?.KepKabulTarih;
this.Kod=item?.Kod||0;
this.Okundu=item?.Okundu;
this.OkunmaTarih=item?.OkunmaTarih;
this.Teslim=item?.Teslim;
this.TeslimTarih=item?.TeslimTarih;
}
}

export class BysKullaniciKlasor {
DegisKullaniciKod?:number;
DegisTarih?:Date;
KayitKullaniciKod?:number;
KayitTarih?:Date;
KlasorAdi?:string;
Kod:number;
KullaniciKod?:number;
UstKod?:number;
BysBelgeTakips:BysBelgeTakip[];
BysKullaniciKlasors:BysKullaniciKlasor[];
GenKullanici?:BysGenKullanici;

constructor(item?:any){
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.KayitKullaniciKod=item?.KayitKullaniciKod;
this.KayitTarih=item?.KayitTarih;
this.KlasorAdi=item?.KlasorAdi;
this.Kod=item?.Kod||0;
this.KullaniciKod=item?.KullaniciKod;
this.UstKod=item?.UstKod;
this.BysBelgeTakips=item?.BysBelgeTakips;
this.BysKullaniciKlasors=item?.BysKullaniciKlasors;
this.GenKullanici=item?.GenKullanici;
}
}

export class BysParametre {
AZamanDamgaKullanici?:string;
AZamanDamgaProv?:string;
AZamanDamgaSifre?:string;
AZamanDamgaUrl?:string;
BelediyeKod:number;
BelgeDogrulamaUrl?:string;
BelgeIcerikKod?:number;
BelgeRootPath?:string;
CalismaPath?:string;
DegisKullaniciKod?:number;
DegisTarih?:Date;
DilKod?:number;
DysServisAdres?:string;
DysTuru?:string;
EimzaEh:string;
EImzaUrl?:string;
EmailBaslikSatir?:string;
EmailSonucSatir?:string;
EvrakNoOtoEh?:string;
GelenBelgeOtoNoEh?:string;
GelisTurKod?:number;
GenelBirimKod?:number;
KayitKullaniciKod:number;
KayitTarih:Date;
KepKullanimEh:string;
Kod:number;
MevzuatLink?:string;
ModulKod:number;
OnayTurKod?:number;
OtoOnayEh?:string;
RaporBaslik1?:string;
RaporBaslik2?:string;
RaporBaslik3?:string;
RaporBaslik4?:string;
SablonDokumanKod?:number;
SablonDysId?:string;
SistemBelgeOtoArsivEh?:string;
YaziMudurKod?:number;
ZamanDamgaKullanici?:string;
ZamanDamgaProv?:string;
ZamanDamgaSifre?:string;
ZamanDamgaUrl?:string;
GenBirim?:BysGenBirim;
GenKodDetay?:BysGenKodDetay;
GenKodDetay1?:BysGenKodDetay;
GenKodDetay2?:BysGenKodDetay;
GenKodDetay3?:BysGenKodDetay;
GenModul:BysGenModul;
IkaPersonel?:BysIkaPersonel;

constructor(item?:any){
this.AZamanDamgaKullanici=item?.AZamanDamgaKullanici;
this.AZamanDamgaProv=item?.AZamanDamgaProv;
this.AZamanDamgaSifre=item?.AZamanDamgaSifre;
this.AZamanDamgaUrl=item?.AZamanDamgaUrl;
this.BelediyeKod=item?.BelediyeKod||0;
this.BelgeDogrulamaUrl=item?.BelgeDogrulamaUrl;
this.BelgeIcerikKod=item?.BelgeIcerikKod;
this.BelgeRootPath=item?.BelgeRootPath;
this.CalismaPath=item?.CalismaPath;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.DilKod=item?.DilKod;
this.DysServisAdres=item?.DysServisAdres;
this.DysTuru=item?.DysTuru;
this.EimzaEh=item?.EimzaEh||'';
this.EImzaUrl=item?.EImzaUrl;
this.EmailBaslikSatir=item?.EmailBaslikSatir;
this.EmailSonucSatir=item?.EmailSonucSatir;
this.EvrakNoOtoEh=item?.EvrakNoOtoEh;
this.GelenBelgeOtoNoEh=item?.GelenBelgeOtoNoEh;
this.GelisTurKod=item?.GelisTurKod;
this.GenelBirimKod=item?.GenelBirimKod;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.KepKullanimEh=item?.KepKullanimEh||'';
this.Kod=item?.Kod||0;
this.MevzuatLink=item?.MevzuatLink;
this.ModulKod=item?.ModulKod||0;
this.OnayTurKod=item?.OnayTurKod;
this.OtoOnayEh=item?.OtoOnayEh;
this.RaporBaslik1=item?.RaporBaslik1;
this.RaporBaslik2=item?.RaporBaslik2;
this.RaporBaslik3=item?.RaporBaslik3;
this.RaporBaslik4=item?.RaporBaslik4;
this.SablonDokumanKod=item?.SablonDokumanKod;
this.SablonDysId=item?.SablonDysId;
this.SistemBelgeOtoArsivEh=item?.SistemBelgeOtoArsivEh;
this.YaziMudurKod=item?.YaziMudurKod;
this.ZamanDamgaKullanici=item?.ZamanDamgaKullanici;
this.ZamanDamgaProv=item?.ZamanDamgaProv;
this.ZamanDamgaSifre=item?.ZamanDamgaSifre;
this.ZamanDamgaUrl=item?.ZamanDamgaUrl;
this.GenBirim=item?.GenBirim;
this.GenKodDetay=item?.GenKodDetay;
this.GenKodDetay1=item?.GenKodDetay1;
this.GenKodDetay2=item?.GenKodDetay2;
this.GenKodDetay3=item?.GenKodDetay3;
this.GenModul=item?.GenModul;
this.IkaPersonel=item?.IkaPersonel;
}
}

export class BysRaporBelge {
BelediyeKod:number;
BelgeAdi?:string;
BelgeIcerikKod?:number;
BelgeTuruKod:number;
BilgiEdinmeEh:string;
DagitimSekli?:string;
DegisKullaniciKod?:number;
DegisTarih?:Date;
DilKod:number;
DosyaPlanKod:string;
EvrakTuru?:string;
GecerliSure?:number;
GelenGiden?:string;
GuvenlikDurumu:number;
KayitKullaniciKod:number;
KayitTarih:Date;
KisiselEh:string;
Kod:number;
KontrolEh:string;
OncelikDurumu:string;
RaporAdi:string;
TelifKapsamindaEh:string;
BysRaporBelgeDagitims:BysRaporBelgeDagitim[];
BysRaporBelgeDetays:BysRaporBelgeDetay[];
GenBelgeTuru:BysGenBelgeTuru;
GenKodDetay:BysGenKodDetay;
GenKodDetay1?:BysGenKodDetay;
GenDosyaPlan:BysGenDosyaPlan;

constructor(item?:any){
this.BelediyeKod=item?.BelediyeKod||0;
this.BelgeAdi=item?.BelgeAdi;
this.BelgeIcerikKod=item?.BelgeIcerikKod;
this.BelgeTuruKod=item?.BelgeTuruKod||0;
this.BilgiEdinmeEh=item?.BilgiEdinmeEh||'';
this.DagitimSekli=item?.DagitimSekli;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.DilKod=item?.DilKod||0;
this.DosyaPlanKod=item?.DosyaPlanKod||'';
this.EvrakTuru=item?.EvrakTuru;
this.GecerliSure=item?.GecerliSure;
this.GelenGiden=item?.GelenGiden;
this.GuvenlikDurumu=item?.GuvenlikDurumu||0;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.KisiselEh=item?.KisiselEh||'';
this.Kod=item?.Kod||0;
this.KontrolEh=item?.KontrolEh||'';
this.OncelikDurumu=item?.OncelikDurumu||'';
this.RaporAdi=item?.RaporAdi||'';
this.TelifKapsamindaEh=item?.TelifKapsamindaEh||'';
this.BysRaporBelgeDagitims=item?.BysRaporBelgeDagitims;
this.BysRaporBelgeDetays=item?.BysRaporBelgeDetays;
this.GenBelgeTuru=item?.GenBelgeTuru;
this.GenKodDetay=item?.GenKodDetay;
this.GenKodDetay1=item?.GenKodDetay1;
this.GenDosyaPlan=item?.GenDosyaPlan;
}
}

export class BysRaporBelgeDagitim {
Aciklama?:string;
BirimKod:number;
DagitimSekli:string;
DegisKullaniciKod?:number;
DegisTarih?:Date;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
RaporBelgeKod:number;
BysRaporBelge:BysRaporBelge;
GenBirim:BysGenBirim;

constructor(item?:any){
this.Aciklama=item?.Aciklama;
this.BirimKod=item?.BirimKod||0;
this.DagitimSekli=item?.DagitimSekli||'';
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.RaporBelgeKod=item?.RaporBelgeKod||0;
this.BysRaporBelge=item?.BysRaporBelge;
this.GenBirim=item?.GenBirim;
}
}

export class BysRaporBelgeDetay {
BirimKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
RaporBelgeKod:number;
SurecKod:number;
BysRaporBelge:BysRaporBelge;
BysSurec:BysSurec;
GenBirim:BysGenBirim;

constructor(item?:any){
this.BirimKod=item?.BirimKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.RaporBelgeKod=item?.RaporBelgeKod||0;
this.SurecKod=item?.SurecKod||0;
this.BysRaporBelge=item?.BysRaporBelge;
this.BysSurec=item?.BysSurec;
this.GenBirim=item?.GenBirim;
}
}

export class BysSablonDokuman {
Aciklama:string;
BelediyeKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
DysId?:string;
ImzaAdet?:number;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;

constructor(item?:any){
this.Aciklama=item?.Aciklama||'';
this.BelediyeKod=item?.BelediyeKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.DysId=item?.DysId;
this.ImzaAdet=item?.ImzaAdet;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
}
}

export class BysSaklamaPlan {
Ad:string;
BelediyeKod:number;
Dayanak?:string;
DegisKullaniciKod?:number;
DegisTarih?:Date;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
Sure?:number;
SureTuru:string;
TasfiyeIslemKod:number;
BysSaklamaPlanKriters:BysSaklamaPlanKriter[];
GenDosyaPlans:BysGenDosyaPlan[];
GenKodDetay:BysGenKodDetay;

constructor(item?:any){
this.Ad=item?.Ad||'';
this.BelediyeKod=item?.BelediyeKod||0;
this.Dayanak=item?.Dayanak;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.Sure=item?.Sure;
this.SureTuru=item?.SureTuru||'';
this.TasfiyeIslemKod=item?.TasfiyeIslemKod||0;
this.BysSaklamaPlanKriters=item?.BysSaklamaPlanKriters;
this.GenDosyaPlans=item?.GenDosyaPlans;
this.GenKodDetay=item?.GenKodDetay;
}
}

export class BysSaklamaPlanKriter {
DegisKullaniciKod?:number;
DegisTarih?:Date;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
SaklamaKriterKod:number;
SaklamaPlanKod:number;
BysSaklamaPlan:BysSaklamaPlan;
GenKodDetay:BysGenKodDetay;

constructor(item?:any){
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.SaklamaKriterKod=item?.SaklamaKriterKod||0;
this.SaklamaPlanKod=item?.SaklamaPlanKod||0;
this.BysSaklamaPlan=item?.BysSaklamaPlan;
this.GenKodDetay=item?.GenKodDetay;
}
}

export class BysSurec {
Ad:string;
AktifEh:string;
BelediyeKod:number;
BirimKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
BysGorevs:BysGorev[];
BysRaporBelgeDetays:BysRaporBelgeDetay[];
BysSurecDetays:BysSurecDetay[];
EksParametres:BysEksParametre[];
GenBirim:BysGenBirim;
GysIcraYazismaTurs:BysGysIcraYazismaTur[];
MksParametres:BysMksParametre[];
YisParametres:BysYisParametre[];

constructor(item?:any){
this.Ad=item?.Ad||'';
this.AktifEh=item?.AktifEh||'';
this.BelediyeKod=item?.BelediyeKod||0;
this.BirimKod=item?.BirimKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.BysGorevs=item?.BysGorevs;
this.BysRaporBelgeDetays=item?.BysRaporBelgeDetays;
this.BysSurecDetays=item?.BysSurecDetays;
this.EksParametres=item?.EksParametres;
this.GenBirim=item?.GenBirim;
this.GysIcraYazismaTurs=item?.GysIcraYazismaTurs;
this.MksParametres=item?.MksParametres;
this.YisParametres=item?.YisParametres;
}
}

export class BysSurecDagitim {
AtanacakGorevKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
GorevKod:number;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
SurecKod:number;
AnaSurecDetay:BysSurecDetay;
AtanacakSurecDetay:BysSurecDetay;

constructor(item?:any){
this.AtanacakGorevKod=item?.AtanacakGorevKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.GorevKod=item?.GorevKod||0;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.SurecKod=item?.SurecKod||0;
this.AnaSurecDetay=item?.AnaSurecDetay;
this.AtanacakSurecDetay=item?.AtanacakSurecDetay;
}
}

export class BysSurecDetay {
BelediyeKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
GorevAd:string;
GorevKod:number;
GorevTuru:number;
ImzaEh:string;
ImzaGorev?:string;
ImzaTuru?:string;
ImzaUnvan?:string;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
MailEh:string;
RolAd?:string;
SmsEh:string;
SonrakiGorevKod?:number;
SurecKod:number;
ZamanDamgaEh:string;
BysSurec:BysSurec;
GenOrganizasyon:BysGenOrganizasyon;

constructor(item?:any){
this.BelediyeKod=item?.BelediyeKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.GorevAd=item?.GorevAd||'';
this.GorevKod=item?.GorevKod||0;
this.GorevTuru=item?.GorevTuru||0;
this.ImzaEh=item?.ImzaEh||'';
this.ImzaGorev=item?.ImzaGorev;
this.ImzaTuru=item?.ImzaTuru;
this.ImzaUnvan=item?.ImzaUnvan;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.MailEh=item?.MailEh||'';
this.RolAd=item?.RolAd;
this.SmsEh=item?.SmsEh||'';
this.SonrakiGorevKod=item?.SonrakiGorevKod;
this.SurecKod=item?.SurecKod||0;
this.ZamanDamgaEh=item?.ZamanDamgaEh||'';
this.BysSurec=item?.BysSurec;
this.GenOrganizasyon=item?.GenOrganizasyon;
}
}

export class BysTaslakSablon {
Aciklama:string;
BelediyeKod:number;
BirimKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
DokumanKod?:number;
DosyaPlanKod:string;
DysId?:string;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
MetinAna?:string;
MetinBas?:string;
MetinBasWord?:string;
MetinSon?:string;
GenBirim:BysGenBirim;
GenDosyaPlan:BysGenDosyaPlan;

constructor(item?:any){
this.Aciklama=item?.Aciklama||'';
this.BelediyeKod=item?.BelediyeKod||0;
this.BirimKod=item?.BirimKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.DokumanKod=item?.DokumanKod;
this.DosyaPlanKod=item?.DosyaPlanKod||'';
this.DysId=item?.DysId;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.MetinAna=item?.MetinAna;
this.MetinBas=item?.MetinBas;
this.MetinBasWord=item?.MetinBasWord;
this.MetinSon=item?.MetinSon;
this.GenBirim=item?.GenBirim;
this.GenDosyaPlan=item?.GenDosyaPlan;
}
}

export class BysUetsAlici {
AdSoyad:string;
DegisKullaniciKod?:number;
DegisTarih?:Date;
Dtn?:string;
Eposta?:string;
FaaliyetAlani?:string;
FizikselAdres?:string;
Gsm?:string;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
MerkezAdres?:string;
Msn?:string;
Tcn?:string;
Telefon?:string;
UetsAdres:string;
Vgn?:string;

constructor(item?:any){
this.AdSoyad=item?.AdSoyad||'';
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.Dtn=item?.Dtn;
this.Eposta=item?.Eposta;
this.FaaliyetAlani=item?.FaaliyetAlani;
this.FizikselAdres=item?.FizikselAdres;
this.Gsm=item?.Gsm;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.MerkezAdres=item?.MerkezAdres;
this.Msn=item?.Msn;
this.Tcn=item?.Tcn;
this.Telefon=item?.Telefon;
this.UetsAdres=item?.UetsAdres||'';
this.Vgn=item?.Vgn;
}
}

export class BysUetsGelen {
AliciAd?:string;
AliciUetsAdres?:string;
Barkod?:string;
BelgeKod?:number;
Boyut?:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
Durum?:string;
Etag?:string;
EypDysId?:string;
GonderenAd?:string;
GonderenUetsAdres?:string;
KayitKullaniciKod:number;
KayitTarih:Date;
KlasorKod?:number;
Kod:number;
Konu?:string;
MesajId?:string;
ReferansId?:string;
Tip?:string;
UetsGuncellemeTarih?:Date;
UetsKayitTarihi?:Date;
BysBelge?:BysBelge;
BysUetsKlasor?:BysUetsKlasor;

constructor(item?:any){
this.AliciAd=item?.AliciAd;
this.AliciUetsAdres=item?.AliciUetsAdres;
this.Barkod=item?.Barkod;
this.BelgeKod=item?.BelgeKod;
this.Boyut=item?.Boyut;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.Durum=item?.Durum;
this.Etag=item?.Etag;
this.EypDysId=item?.EypDysId;
this.GonderenAd=item?.GonderenAd;
this.GonderenUetsAdres=item?.GonderenUetsAdres;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.KlasorKod=item?.KlasorKod;
this.Kod=item?.Kod||0;
this.Konu=item?.Konu;
this.MesajId=item?.MesajId;
this.ReferansId=item?.ReferansId;
this.Tip=item?.Tip;
this.UetsGuncellemeTarih=item?.UetsGuncellemeTarih;
this.UetsKayitTarihi=item?.UetsKayitTarihi;
this.BysBelge=item?.BysBelge;
this.BysUetsKlasor=item?.BysUetsKlasor;
}
}

export class BysUetsGiden {
AliciAd?:string;
AliciRef?:string;
AliciUetsAdres:string;
Barkod?:string;
Boyut?:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
Durum:string;
Etag?:string;
EypDysId?:string;
GonderenAd?:string;
GonderenRef?:string;
GonderimTarih?:Date;
GuncellemeTarih?:Date;
KayitKullaniciKod:number;
KayitTarih:Date;
KlasorKod?:number;
Kod:number;
Konu:string;
MesajId?:string;
ReferansId?:string;
Status:number;
BysUetsGidenDelils:BysUetsGidenDelil[];

constructor(item?:any){
this.AliciAd=item?.AliciAd;
this.AliciRef=item?.AliciRef;
this.AliciUetsAdres=item?.AliciUetsAdres||'';
this.Barkod=item?.Barkod;
this.Boyut=item?.Boyut;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.Durum=item?.Durum||'';
this.Etag=item?.Etag;
this.EypDysId=item?.EypDysId;
this.GonderenAd=item?.GonderenAd;
this.GonderenRef=item?.GonderenRef;
this.GonderimTarih=item?.GonderimTarih;
this.GuncellemeTarih=item?.GuncellemeTarih;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.KlasorKod=item?.KlasorKod;
this.Kod=item?.Kod||0;
this.Konu=item?.Konu||'';
this.MesajId=item?.MesajId;
this.ReferansId=item?.ReferansId;
this.Status=item?.Status||0;
this.BysUetsGidenDelils=item?.BysUetsGidenDelils;
}
}

export class BysUetsGidenDelil {
DegisKullaniciKod?:number;
DegisTarih?:Date;
DelilId:string;
DelilOlay:string;
DelilTarih:Date;
DelilTip:string;
GidenKod:number;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
BysUetsGiden:BysUetsGiden;

constructor(item?:any){
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.DelilId=item?.DelilId||'';
this.DelilOlay=item?.DelilOlay||'';
this.DelilTarih=item?.DelilTarih||new Date();
this.DelilTip=item?.DelilTip||'';
this.GidenKod=item?.GidenKod||0;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.BysUetsGiden=item?.BysUetsGiden;
}
}

export class BysUetsKlasor {
DegisKullaniciKod?:number;
DegisTarih?:Date;
Durum?:string;
KayitKullaniciKod:number;
KayitTarih:Date;
KlasorAdi:string;
KlasorId:number;
Kod:number;
OkunmamisSayisi?:number;
Tip?:string;
ToplamBoyut?:number;
ToplamSayi?:number;
BysUetsGelens:BysUetsGelen[];

constructor(item?:any){
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.Durum=item?.Durum;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.KlasorAdi=item?.KlasorAdi||'';
this.KlasorId=item?.KlasorId||0;
this.Kod=item?.Kod||0;
this.OkunmamisSayisi=item?.OkunmamisSayisi;
this.Tip=item?.Tip;
this.ToplamBoyut=item?.ToplamBoyut;
this.ToplamSayi=item?.ToplamSayi;
this.BysUetsGelens=item?.BysUetsGelens;
}
}

export class BysUetsParametre {
BelediyeKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
KayitKullaniciKod?:number;
KayitTarih?:Date;
Kod:number;
KurumApiKey?:string;
KurumUetsAdres?:string;
KurumUetsEh?:string;

constructor(item?:any){
this.BelediyeKod=item?.BelediyeKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.KayitKullaniciKod=item?.KayitKullaniciKod;
this.KayitTarih=item?.KayitTarih;
this.Kod=item?.Kod||0;
this.KurumApiKey=item?.KurumApiKey;
this.KurumUetsAdres=item?.KurumUetsAdres;
this.KurumUetsEh=item?.KurumUetsEh;
}
}

export class BysAksParsel {
AcilisTarih?:Date;
Ada:number;
AktifEh:string;
Alani?:number;
BelediyeKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
GeciciAda?:string;
GeciciParsel?:string;
KapanisTarih?:Date;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
MahalleKod:number;
Pafta?:string;
Parsel:number;
ParselBolgeKod:number;
ParselTipiKod?:number;
TapuMahalleKod?:number;

constructor(item?:any){
this.AcilisTarih=item?.AcilisTarih;
this.Ada=item?.Ada||0;
this.AktifEh=item?.AktifEh||'';
this.Alani=item?.Alani;
this.BelediyeKod=item?.BelediyeKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.GeciciAda=item?.GeciciAda;
this.GeciciParsel=item?.GeciciParsel;
this.KapanisTarih=item?.KapanisTarih;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.MahalleKod=item?.MahalleKod||0;
this.Pafta=item?.Pafta;
this.Parsel=item?.Parsel||0;
this.ParselBolgeKod=item?.ParselBolgeKod||0;
this.ParselTipiKod=item?.ParselTipiKod;
this.TapuMahalleKod=item?.TapuMahalleKod;
}
}

export class BysGasDosya {
Ada?:number;
BelediyeKod:number;
BinaKod?:number;
BirimDosyaKod:number;
BirimKod:number;
BlokNo?:string;
BolumKod?:number;
DaireNo?:string;
DegisKullaniciKod?:number;
DegisTarih?:Date;
DepoKod?:number;
DosyaBarkod?:string;
DosyaDurum:string;
DosyaNo:string;
DosyaPlanKod:string;
DosyaTuru:string;
EskiKisiKod?:number;
EvlenBeyanKod?:number;
GirisTarih:Date;
IhaleDosyaKod?:number;
ImhaTarih?:Date;
IsyeriRuhsatKod?:number;
KapamaTarih?:Date;
KapiNo?:number;
KapiNo1?:string;
KatNo?:string;
KayitKullaniciKod:number;
KayitTarih:Date;
KisiAciklama?:string;
KisiKod?:number;
KlasorAd?:string;
KlasorAdet?:number;
KlasorBarkod?:string;
Kod:number;
KutuAd?:string;
KutuBarkod?:string;
MahalleCaddeKod?:number;
Notlar?:string;
OzelDosyaKod?:number;
Pafta?:string;
Parsel?:number;
ParselKod?:number;
PazarBeyanKod?:number;
PersonelKod?:number;
SaklamaSure?:number;
SiteApartmanAd?:string;
SuAboneKod?:number;
TasinmazKod?:number;
TasnifYapildiEh?:string;
YeniDosyaKod?:number;
YerBlokKod?:number;
YerGozKod?:number;
YerRafKod?:number;
Yil:number;

constructor(item?:any){
this.Ada=item?.Ada;
this.BelediyeKod=item?.BelediyeKod||0;
this.BinaKod=item?.BinaKod;
this.BirimDosyaKod=item?.BirimDosyaKod||0;
this.BirimKod=item?.BirimKod||0;
this.BlokNo=item?.BlokNo;
this.BolumKod=item?.BolumKod;
this.DaireNo=item?.DaireNo;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.DepoKod=item?.DepoKod;
this.DosyaBarkod=item?.DosyaBarkod;
this.DosyaDurum=item?.DosyaDurum||'';
this.DosyaNo=item?.DosyaNo||'';
this.DosyaPlanKod=item?.DosyaPlanKod||'';
this.DosyaTuru=item?.DosyaTuru||'';
this.EskiKisiKod=item?.EskiKisiKod;
this.EvlenBeyanKod=item?.EvlenBeyanKod;
this.GirisTarih=item?.GirisTarih||new Date();
this.IhaleDosyaKod=item?.IhaleDosyaKod;
this.ImhaTarih=item?.ImhaTarih;
this.IsyeriRuhsatKod=item?.IsyeriRuhsatKod;
this.KapamaTarih=item?.KapamaTarih;
this.KapiNo=item?.KapiNo;
this.KapiNo1=item?.KapiNo1;
this.KatNo=item?.KatNo;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.KisiAciklama=item?.KisiAciklama;
this.KisiKod=item?.KisiKod;
this.KlasorAd=item?.KlasorAd;
this.KlasorAdet=item?.KlasorAdet;
this.KlasorBarkod=item?.KlasorBarkod;
this.Kod=item?.Kod||0;
this.KutuAd=item?.KutuAd;
this.KutuBarkod=item?.KutuBarkod;
this.MahalleCaddeKod=item?.MahalleCaddeKod;
this.Notlar=item?.Notlar;
this.OzelDosyaKod=item?.OzelDosyaKod;
this.Pafta=item?.Pafta;
this.Parsel=item?.Parsel;
this.ParselKod=item?.ParselKod;
this.PazarBeyanKod=item?.PazarBeyanKod;
this.PersonelKod=item?.PersonelKod;
this.SaklamaSure=item?.SaklamaSure;
this.SiteApartmanAd=item?.SiteApartmanAd;
this.SuAboneKod=item?.SuAboneKod;
this.TasinmazKod=item?.TasinmazKod;
this.TasnifYapildiEh=item?.TasnifYapildiEh;
this.YeniDosyaKod=item?.YeniDosyaKod;
this.YerBlokKod=item?.YerBlokKod;
this.YerGozKod=item?.YerGozKod;
this.YerRafKod=item?.YerRafKod;
this.Yil=item?.Yil||0;
}
}

export class BysGasDosyaBelge {
Ada?:number;
BelgeAd?:string;
BelgeBarkod?:string;
BelgeDysKod?:string;
BelgeKod?:number;
BelgeNo?:string;
BelgePath?:string;
BelgeTarih:Date;
BelgeTipKod:number;
BelgeTuruKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
DosyaKod:number;
DosyaPlanKod?:string;
EskiKisiKod?:number;
KayitKullaniciKod:number;
KayitTarih:Date;
KisaNotlar?:string;
KisiAciklama?:string;
KisiKod?:number;
Kod:number;
Notlar?:string;
Pafta?:string;
Parsel?:number;
ParselKod?:number;
PersonelKod?:number;
SaklamaSure?:number;

constructor(item?:any){
this.Ada=item?.Ada;
this.BelgeAd=item?.BelgeAd;
this.BelgeBarkod=item?.BelgeBarkod;
this.BelgeDysKod=item?.BelgeDysKod;
this.BelgeKod=item?.BelgeKod;
this.BelgeNo=item?.BelgeNo;
this.BelgePath=item?.BelgePath;
this.BelgeTarih=item?.BelgeTarih||new Date();
this.BelgeTipKod=item?.BelgeTipKod||0;
this.BelgeTuruKod=item?.BelgeTuruKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.DosyaKod=item?.DosyaKod||0;
this.DosyaPlanKod=item?.DosyaPlanKod;
this.EskiKisiKod=item?.EskiKisiKod;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.KisaNotlar=item?.KisaNotlar;
this.KisiAciklama=item?.KisiAciklama;
this.KisiKod=item?.KisiKod;
this.Kod=item?.Kod||0;
this.Notlar=item?.Notlar;
this.Pafta=item?.Pafta;
this.Parsel=item?.Parsel;
this.ParselKod=item?.ParselKod;
this.PersonelKod=item?.PersonelKod;
this.SaklamaSure=item?.SaklamaSure;
}
}

export class BysGenBelgeTuru {
Ad:string;
AktifEh:string;
BelediyeKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
DosyaPlanKod?:string;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
UstKod?:number;

constructor(item?:any){
this.Ad=item?.Ad||'';
this.AktifEh=item?.AktifEh||'';
this.BelediyeKod=item?.BelediyeKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.DosyaPlanKod=item?.DosyaPlanKod;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.UstKod=item?.UstKod;
}
}

export class BysGenBirim {
Ad:string;
AktifEh:string;
AnaBirimKod?:number;
BelediyeKod:number;
BirimAdres?:string;
BirimEPosta?:string;
BirimTuru:string;
BirimWebAdres?:string;
DegisKullaniciKod?:number;
DegisTarih?:Date;
EypPaketEh?:string;
FaxAlanKod?:number;
FaxNo?:string;
KayitKullaniciKod:number;
KayitTarih:Date;
KepEposta?:string;
KimlikNo:number;
KisaAd?:string;
KisiKod?:number;
Kod:number;
Notlar?:string;
Seviye?:number;
TelAlanKod?:number;
TelNo?:string;
UetsAdres?:string;
YetkiliAdSoyad?:string;
YetkiliPersonelKod?:number;
YetkiliTelNo?:string;
YetkiliUnvani?:string;

constructor(item?:any){
this.Ad=item?.Ad||'';
this.AktifEh=item?.AktifEh||'';
this.AnaBirimKod=item?.AnaBirimKod;
this.BelediyeKod=item?.BelediyeKod||0;
this.BirimAdres=item?.BirimAdres;
this.BirimEPosta=item?.BirimEPosta;
this.BirimTuru=item?.BirimTuru||'';
this.BirimWebAdres=item?.BirimWebAdres;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.EypPaketEh=item?.EypPaketEh;
this.FaxAlanKod=item?.FaxAlanKod;
this.FaxNo=item?.FaxNo;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.KepEposta=item?.KepEposta;
this.KimlikNo=item?.KimlikNo||0;
this.KisaAd=item?.KisaAd;
this.KisiKod=item?.KisiKod;
this.Kod=item?.Kod||0;
this.Notlar=item?.Notlar;
this.Seviye=item?.Seviye;
this.TelAlanKod=item?.TelAlanKod;
this.TelNo=item?.TelNo;
this.UetsAdres=item?.UetsAdres;
this.YetkiliAdSoyad=item?.YetkiliAdSoyad;
this.YetkiliPersonelKod=item?.YetkiliPersonelKod;
this.YetkiliTelNo=item?.YetkiliTelNo;
this.YetkiliUnvani=item?.YetkiliUnvani;
}
}

export class BysGenKisi {
Aciklama?:string;
Ad?:string;
AnneAd?:string;
BabaAd?:string;
BelediyeKod:number;
Cinsiyet?:string;
DegisKullaniciKod?:number;
DegisTarih?:Date;
DiniKod?:number;
DogumTarih?:Date;
DogumYeriAciklama?:string;
DogumYeriKod?:number;
EhliyetNo?:string;
EhliyetTarih?:Date;
EhliyetTuruKod?:number;
EmekliTarih?:Date;
EmekliTuruKod?:number;
IsyeriTuruKod?:number;
KanGrubu?:string;
KayitKullaniciKod:number;
KayitTarih:Date;
KepAdres?:string;
KisiTurKod:number;
Kod:number;
KpsKod?:string;
KpsKontrolTarih?:Date;
KpsSonucTur?:number;
MedeniDurumKod?:number;
MeslekAciklama?:string;
MeslekKod?:number;
NAileSiraNo?:string;
NCiltNo?:string;
NCuzdanKayitNo?:string;
NCuzdanSeriNo?:string;
NCuzdanSiraNo?:number;
NCuzdanVerilisKod?:number;
NIdaresiKod?:number;
NKayitliMahalleKoy?:string;
NKayitliYerKod?:number;
NSiraNo?:string;
NVerildigiTarih?:Date;
OgrenimTuruKod?:number;
OlumKapanisTarih?:Date;
OncekiSoyad?:string;
SicilKod:number;
Soyad?:string;
Tckn?:number;
UetsAdres?:string;
Unvani?:string;
UyrukKod?:number;
VarisEh?:string;
VergiDairesi?:string;
VergiNo?:string;
AdSoyadUnvan:string;

constructor(item?:any){
this.Aciklama=item?.Aciklama;
this.Ad=item?.Ad;
this.AnneAd=item?.AnneAd;
this.BabaAd=item?.BabaAd;
this.BelediyeKod=item?.BelediyeKod||0;
this.Cinsiyet=item?.Cinsiyet;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.DiniKod=item?.DiniKod;
this.DogumTarih=item?.DogumTarih;
this.DogumYeriAciklama=item?.DogumYeriAciklama;
this.DogumYeriKod=item?.DogumYeriKod;
this.EhliyetNo=item?.EhliyetNo;
this.EhliyetTarih=item?.EhliyetTarih;
this.EhliyetTuruKod=item?.EhliyetTuruKod;
this.EmekliTarih=item?.EmekliTarih;
this.EmekliTuruKod=item?.EmekliTuruKod;
this.IsyeriTuruKod=item?.IsyeriTuruKod;
this.KanGrubu=item?.KanGrubu;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.KepAdres=item?.KepAdres;
this.KisiTurKod=item?.KisiTurKod||0;
this.Kod=item?.Kod||0;
this.KpsKod=item?.KpsKod;
this.KpsKontrolTarih=item?.KpsKontrolTarih;
this.KpsSonucTur=item?.KpsSonucTur;
this.MedeniDurumKod=item?.MedeniDurumKod;
this.MeslekAciklama=item?.MeslekAciklama;
this.MeslekKod=item?.MeslekKod;
this.NAileSiraNo=item?.NAileSiraNo;
this.NCiltNo=item?.NCiltNo;
this.NCuzdanKayitNo=item?.NCuzdanKayitNo;
this.NCuzdanSeriNo=item?.NCuzdanSeriNo;
this.NCuzdanSiraNo=item?.NCuzdanSiraNo;
this.NCuzdanVerilisKod=item?.NCuzdanVerilisKod;
this.NIdaresiKod=item?.NIdaresiKod;
this.NKayitliMahalleKoy=item?.NKayitliMahalleKoy;
this.NKayitliYerKod=item?.NKayitliYerKod;
this.NSiraNo=item?.NSiraNo;
this.NVerildigiTarih=item?.NVerildigiTarih;
this.OgrenimTuruKod=item?.OgrenimTuruKod;
this.OlumKapanisTarih=item?.OlumKapanisTarih;
this.OncekiSoyad=item?.OncekiSoyad;
this.SicilKod=item?.SicilKod||0;
this.Soyad=item?.Soyad;
this.Tckn=item?.Tckn;
this.UetsAdres=item?.UetsAdres;
this.Unvani=item?.Unvani;
this.UyrukKod=item?.UyrukKod;
this.VarisEh=item?.VarisEh;
this.VergiDairesi=item?.VergiDairesi;
this.VergiNo=item?.VergiNo;
this.AdSoyadUnvan=item?.AdSoyadUnvan||'';
}
}

export class BysGenKodDetay {
Ad:string;
AnaKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
OzelKod?:number;
OzelKodStr?:string;
ReferansKod?:string;

constructor(item?:any){
this.Ad=item?.Ad||'';
this.AnaKod=item?.AnaKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.OzelKod=item?.OzelKod;
this.OzelKodStr=item?.OzelKodStr;
this.ReferansKod=item?.ReferansKod;
}
}

export class BysGysIcraBelge {
Aciklama?:string;
DegisKullaniciKod?:number;
DegisTarih?:Date;
GelenBelgeKod?:number;
GelenEvrakNo?:number;
GenelEvrakTarih?:Date;
GidenBelgeKod?:number;
GidenEvrakNo?:number;
GidenEvrakTarih?:Date;
IcraAnaKod:number;
IcraYazismaTurKod:number;
KarsilikYazilacakEh:string;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
YaziTuru:number;

constructor(item?:any){
this.Aciklama=item?.Aciklama;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.GelenBelgeKod=item?.GelenBelgeKod;
this.GelenEvrakNo=item?.GelenEvrakNo;
this.GenelEvrakTarih=item?.GenelEvrakTarih;
this.GidenBelgeKod=item?.GidenBelgeKod;
this.GidenEvrakNo=item?.GidenEvrakNo;
this.GidenEvrakTarih=item?.GidenEvrakTarih;
this.IcraAnaKod=item?.IcraAnaKod||0;
this.IcraYazismaTurKod=item?.IcraYazismaTurKod||0;
this.KarsilikYazilacakEh=item?.KarsilikYazilacakEh||'';
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.YaziTuru=item?.YaziTuru||0;
}
}

export class BysIkaPersonel {
Aciklama?:string;
Ad?:string;
AktifEh?:string;
AnneAd?:string;
BabaAd?:string;
BelediyeKod:number;
CikisNedeni?:string;
CikisTarih?:Date;
CikisTurKod?:number;
Cinsiyet?:string;
DahiliTelefon?:string;
DegisKullaniciKod?:number;
DegisTarih?:Date;
DiniKod?:number;
DogumTarih?:Date;
DogumYeriAciklama?:string;
DogumYeriKod?:number;
EhliyetNo?:number;
EhliyetTarih?:Date;
EhliyetTuru?:string;
EhliyetTuruKod?:number;
EMail?:string;
EmekliGorevTarih?:Date;
EmekliSandikNo?:string;
EmekliYeniSandikNo?:string;
GorevBirimKod?:number;
GorevUnvanKod?:number;
GsmAlanKod?:number;
GsmTelefon?:string;
GssNo?:string;
IbanNo?:string;
IlkGirisTarih:Date;
IzinBaslangicTarih:Date;
KadroBirimKod?:number;
KadroUnvanKod?:number;
KanGrubu?:string;
KayitKullaniciKod:number;
KayitTarih:Date;
KefaletCuzdanNo?:string;
KepPosta?:string;
KisiKod?:number;
Kod:number;
KpsKod?:string;
KpsKontrolTarih?:Date;
KurumGirisTarih?:Date;
KurumSicilNo?:string;
KurumUnvanKod?:number;
MailBilgiEh?:string;
MalulKod?:number;
MedeniDurumKod?:number;
NAileSiraNo?:string;
NCiltNo?:string;
NCuzdanKayitNo?:number;
NCuzdanSeriNo?:string;
NCuzdanSiraNo?:number;
NCuzdanVerilisKod?:number;
NIdaresiKod?:number;
NKayitliMahalleKoy?:string;
NKayitliYerKod?:number;
NSiraNo?:string;
NVerildigiTarih?:Date;
OncekiSoyad?:string;
PersonelKod:number;
PersonelTurKod:number;
SakatlikGrup?:string;
SebepKod?:number;
SgkMeslekKod?:number;
SmsBilgiEh?:string;
Soyad?:string;
SskNo?:string;
TasarrufNo?:string;
TaseronFirmaKod?:number;
Tckn?:number;
UnvanKod?:number;
UyrukKod?:number;
VergiDairesi?:string;
VergiNo?:string;

constructor(item?:any){
this.Aciklama=item?.Aciklama;
this.Ad=item?.Ad;
this.AktifEh=item?.AktifEh;
this.AnneAd=item?.AnneAd;
this.BabaAd=item?.BabaAd;
this.BelediyeKod=item?.BelediyeKod||0;
this.CikisNedeni=item?.CikisNedeni;
this.CikisTarih=item?.CikisTarih;
this.CikisTurKod=item?.CikisTurKod;
this.Cinsiyet=item?.Cinsiyet;
this.DahiliTelefon=item?.DahiliTelefon;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.DiniKod=item?.DiniKod;
this.DogumTarih=item?.DogumTarih;
this.DogumYeriAciklama=item?.DogumYeriAciklama;
this.DogumYeriKod=item?.DogumYeriKod;
this.EhliyetNo=item?.EhliyetNo;
this.EhliyetTarih=item?.EhliyetTarih;
this.EhliyetTuru=item?.EhliyetTuru;
this.EhliyetTuruKod=item?.EhliyetTuruKod;
this.EMail=item?.EMail;
this.EmekliGorevTarih=item?.EmekliGorevTarih;
this.EmekliSandikNo=item?.EmekliSandikNo;
this.EmekliYeniSandikNo=item?.EmekliYeniSandikNo;
this.GorevBirimKod=item?.GorevBirimKod;
this.GorevUnvanKod=item?.GorevUnvanKod;
this.GsmAlanKod=item?.GsmAlanKod;
this.GsmTelefon=item?.GsmTelefon;
this.GssNo=item?.GssNo;
this.IbanNo=item?.IbanNo;
this.IlkGirisTarih=item?.IlkGirisTarih||new Date();
this.IzinBaslangicTarih=item?.IzinBaslangicTarih||new Date();
this.KadroBirimKod=item?.KadroBirimKod;
this.KadroUnvanKod=item?.KadroUnvanKod;
this.KanGrubu=item?.KanGrubu;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.KefaletCuzdanNo=item?.KefaletCuzdanNo;
this.KepPosta=item?.KepPosta;
this.KisiKod=item?.KisiKod;
this.Kod=item?.Kod||0;
this.KpsKod=item?.KpsKod;
this.KpsKontrolTarih=item?.KpsKontrolTarih;
this.KurumGirisTarih=item?.KurumGirisTarih;
this.KurumSicilNo=item?.KurumSicilNo;
this.KurumUnvanKod=item?.KurumUnvanKod;
this.MailBilgiEh=item?.MailBilgiEh;
this.MalulKod=item?.MalulKod;
this.MedeniDurumKod=item?.MedeniDurumKod;
this.NAileSiraNo=item?.NAileSiraNo;
this.NCiltNo=item?.NCiltNo;
this.NCuzdanKayitNo=item?.NCuzdanKayitNo;
this.NCuzdanSeriNo=item?.NCuzdanSeriNo;
this.NCuzdanSiraNo=item?.NCuzdanSiraNo;
this.NCuzdanVerilisKod=item?.NCuzdanVerilisKod;
this.NIdaresiKod=item?.NIdaresiKod;
this.NKayitliMahalleKoy=item?.NKayitliMahalleKoy;
this.NKayitliYerKod=item?.NKayitliYerKod;
this.NSiraNo=item?.NSiraNo;
this.NVerildigiTarih=item?.NVerildigiTarih;
this.OncekiSoyad=item?.OncekiSoyad;
this.PersonelKod=item?.PersonelKod||0;
this.PersonelTurKod=item?.PersonelTurKod||0;
this.SakatlikGrup=item?.SakatlikGrup;
this.SebepKod=item?.SebepKod;
this.SgkMeslekKod=item?.SgkMeslekKod;
this.SmsBilgiEh=item?.SmsBilgiEh;
this.Soyad=item?.Soyad;
this.SskNo=item?.SskNo;
this.TasarrufNo=item?.TasarrufNo;
this.TaseronFirmaKod=item?.TaseronFirmaKod;
this.Tckn=item?.Tckn;
this.UnvanKod=item?.UnvanKod;
this.UyrukKod=item?.UyrukKod;
this.VergiDairesi=item?.VergiDairesi;
this.VergiNo=item?.VergiNo;
}
}

export class BysYisKarar {
AnahtarKelime?:string;
BelediyeKod:number;
BelgeKod?:number;
BirimKod:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
DurumKod?:number;
DysKod?:string;
GelisSekliKod?:number;
GenelArsivKod?:number;
GrupTurKod:number;
GundemeIlaveEh:string;
GundemNo?:number;
GundemToplantiKod?:number;
IhaleBedeli?:number;
IhaleDuyuruSekli?:string;
IhaleGerekcesi?:string;
IhaleSiraNo?:number;
IhaleTurKod?:number;
IhaleUsulu?:string;
ImzaDysKod?:string;
IsinCinsi?:string;
KararAciklama?:string;
KararEkNo?:string;
KararIcerik?:string;
KararKesinlesmeSayi?:string;
KararKesinlesmeTarih?:Date;
KararNo?:string;
KararOnayTarih?:Date;
KararOzet?:string;
KararSaati?:string;
KararSekliKod?:number;
KararSonuc?:string;
KararTarih?:Date;
KararToplantiKod?:number;
KararTuru?:string;
KararYerKod?:number;
KararYururlulukSayi?:string;
KararYururlulukTarih?:Date;
KatilanKisi?:number;
KayitKullaniciKod?:number;
KayitTarih?:Date;
KazananFirma?:string;
KazananFirmaKod?:number;
KelimeIslemci?:string;
KisiKod?:number;
Kod:number;
KomisyonKod?:number;
KonuKod:number;
MeclisNo?:string;
OnayBelgeTarihNo?:string;
OnergeMetni?:string;
OnergeTarihi?:Date;
OylamaTurKod?:number;
ParaCezasiEh?:string;
ParaCezasiTutari?:number;
SonucTurKod?:number;
TahminiBedel?:number;
TalepTarih?:Date;
Tckn?:number;
WebYayiniEh:string;
YardimEh?:string;
YardimTutar?:number;
YazimTuru?:string;

constructor(item?:any){
this.AnahtarKelime=item?.AnahtarKelime;
this.BelediyeKod=item?.BelediyeKod||0;
this.BelgeKod=item?.BelgeKod;
this.BirimKod=item?.BirimKod||0;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.DurumKod=item?.DurumKod;
this.DysKod=item?.DysKod;
this.GelisSekliKod=item?.GelisSekliKod;
this.GenelArsivKod=item?.GenelArsivKod;
this.GrupTurKod=item?.GrupTurKod||0;
this.GundemeIlaveEh=item?.GundemeIlaveEh||'';
this.GundemNo=item?.GundemNo;
this.GundemToplantiKod=item?.GundemToplantiKod;
this.IhaleBedeli=item?.IhaleBedeli;
this.IhaleDuyuruSekli=item?.IhaleDuyuruSekli;
this.IhaleGerekcesi=item?.IhaleGerekcesi;
this.IhaleSiraNo=item?.IhaleSiraNo;
this.IhaleTurKod=item?.IhaleTurKod;
this.IhaleUsulu=item?.IhaleUsulu;
this.ImzaDysKod=item?.ImzaDysKod;
this.IsinCinsi=item?.IsinCinsi;
this.KararAciklama=item?.KararAciklama;
this.KararEkNo=item?.KararEkNo;
this.KararIcerik=item?.KararIcerik;
this.KararKesinlesmeSayi=item?.KararKesinlesmeSayi;
this.KararKesinlesmeTarih=item?.KararKesinlesmeTarih;
this.KararNo=item?.KararNo;
this.KararOnayTarih=item?.KararOnayTarih;
this.KararOzet=item?.KararOzet;
this.KararSaati=item?.KararSaati;
this.KararSekliKod=item?.KararSekliKod;
this.KararSonuc=item?.KararSonuc;
this.KararTarih=item?.KararTarih;
this.KararToplantiKod=item?.KararToplantiKod;
this.KararTuru=item?.KararTuru;
this.KararYerKod=item?.KararYerKod;
this.KararYururlulukSayi=item?.KararYururlulukSayi;
this.KararYururlulukTarih=item?.KararYururlulukTarih;
this.KatilanKisi=item?.KatilanKisi;
this.KayitKullaniciKod=item?.KayitKullaniciKod;
this.KayitTarih=item?.KayitTarih;
this.KazananFirma=item?.KazananFirma;
this.KazananFirmaKod=item?.KazananFirmaKod;
this.KelimeIslemci=item?.KelimeIslemci;
this.KisiKod=item?.KisiKod;
this.Kod=item?.Kod||0;
this.KomisyonKod=item?.KomisyonKod;
this.KonuKod=item?.KonuKod||0;
this.MeclisNo=item?.MeclisNo;
this.OnayBelgeTarihNo=item?.OnayBelgeTarihNo;
this.OnergeMetni=item?.OnergeMetni;
this.OnergeTarihi=item?.OnergeTarihi;
this.OylamaTurKod=item?.OylamaTurKod;
this.ParaCezasiEh=item?.ParaCezasiEh;
this.ParaCezasiTutari=item?.ParaCezasiTutari;
this.SonucTurKod=item?.SonucTurKod;
this.TahminiBedel=item?.TahminiBedel;
this.TalepTarih=item?.TalepTarih;
this.Tckn=item?.Tckn;
this.WebYayiniEh=item?.WebYayiniEh||'';
this.YardimEh=item?.YardimEh;
this.YardimTutar=item?.YardimTutar;
this.YazimTuru=item?.YazimTuru;
}
}

export class BysGenDosyaPlan {
Ad:string;
BelediyeKod:number;
Dayanak?:string;
DegisKullaniciKod?:number;
DegisTarih?:Date;
DosyaPlanKod:string;
KayitKullaniciKod:number;
KayitTarih:Date;
KlasorTuru?:string;
Kod:number;
KonuBoyut?:number;
KonuTarihTuru?:string;
KonuTuru?:string;
SaklamaPlanKod?:number;
Seviye?:number;
Sure?:number;
SureTuru?:string;
TasfiyeIslemKod?:number;

constructor(item?:any){
this.Ad=item?.Ad||'';
this.BelediyeKod=item?.BelediyeKod||0;
this.Dayanak=item?.Dayanak;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.DosyaPlanKod=item?.DosyaPlanKod||'';
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.KlasorTuru=item?.KlasorTuru;
this.Kod=item?.Kod||0;
this.KonuBoyut=item?.KonuBoyut;
this.KonuTarihTuru=item?.KonuTarihTuru;
this.KonuTuru=item?.KonuTuru;
this.SaklamaPlanKod=item?.SaklamaPlanKod;
this.Seviye=item?.Seviye;
this.Sure=item?.Sure;
this.SureTuru=item?.SureTuru;
this.TasfiyeIslemKod=item?.TasfiyeIslemKod;
}
}

export class BysGenBelgeTip {
Ad:string;
DegisKullaniciKod?:number;
DegisTarih?:Date;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
Turu:number;
Uzanti:string;

constructor(item?:any){
this.Ad=item?.Ad||'';
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.Turu=item?.Turu||0;
this.Uzanti=item?.Uzanti||'';
}
}

export class BysGenBirimIletisim {
Ad:string;
AktifEh:string;
BirimAdres?:string;
BirimEPosta?:string;
BirimKod?:number;
BirimWebAdres?:string;
DegisKullaniciKod?:number;
DegisTarih?:Date;
FaxAlanKod?:number;
FaxNo?:string;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
Notlar?:string;
TelAlanKod?:number;
TelNo?:string;
YetkiliAdSoyad?:string;
YetkiliPersonelKod?:number;
YetkiliTelNo?:string;
YetkiliUnvani?:string;

constructor(item?:any){
this.Ad=item?.Ad||'';
this.AktifEh=item?.AktifEh||'';
this.BirimAdres=item?.BirimAdres;
this.BirimEPosta=item?.BirimEPosta;
this.BirimKod=item?.BirimKod;
this.BirimWebAdres=item?.BirimWebAdres;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.FaxAlanKod=item?.FaxAlanKod;
this.FaxNo=item?.FaxNo;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.Notlar=item?.Notlar;
this.TelAlanKod=item?.TelAlanKod;
this.TelNo=item?.TelNo;
this.YetkiliAdSoyad=item?.YetkiliAdSoyad;
this.YetkiliPersonelKod=item?.YetkiliPersonelKod;
this.YetkiliTelNo=item?.YetkiliTelNo;
this.YetkiliUnvani=item?.YetkiliUnvani;
}
}

export class BysGenKullanici {
Adi:string;
AktifEh:string;
BelediyeKod:number;
DabId?:string;
DegisKullaniciKod?:number;
DegisTarih?:Date;
EkranRenk?:string;
GoruntuRenk?:string;
GrafikEh?:string;
GsmTelefonNo?:string;
GuiId?:string;
IpKisitEh?:string;
KayitKullaniciKod:number;
KayitRenk?:string;
KayitTarih:Date;
Kod:number;
KullaniciKod:string;
KullaniciTip?:string;
LdapEh?:string;
LdapKullaniciAd?:string;
PersonelKod?:number;
Sifre:string;
SifreGunu?:number;
SifreTarihi?:Date;
Soyadi:string;
Tema:number;
TempData?:string;
YaziRenk?:string;

constructor(item?:any){
this.Adi=item?.Adi||'';
this.AktifEh=item?.AktifEh||'';
this.BelediyeKod=item?.BelediyeKod||0;
this.DabId=item?.DabId;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.EkranRenk=item?.EkranRenk;
this.GoruntuRenk=item?.GoruntuRenk;
this.GrafikEh=item?.GrafikEh;
this.GsmTelefonNo=item?.GsmTelefonNo;
this.GuiId=item?.GuiId;
this.IpKisitEh=item?.IpKisitEh;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitRenk=item?.KayitRenk;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.KullaniciKod=item?.KullaniciKod||'';
this.KullaniciTip=item?.KullaniciTip;
this.LdapEh=item?.LdapEh;
this.LdapKullaniciAd=item?.LdapKullaniciAd;
this.PersonelKod=item?.PersonelKod;
this.Sifre=item?.Sifre||'';
this.SifreGunu=item?.SifreGunu;
this.SifreTarihi=item?.SifreTarihi;
this.Soyadi=item?.Soyadi||'';
this.Tema=item?.Tema||0;
this.TempData=item?.TempData;
this.YaziRenk=item?.YaziRenk;
}
}

export class BysGenOrganizasyon {
AktifEh:string;
BelediyeKod:number;
BirimKod?:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
KadroAdet?:number;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
RolAciklama:string;
RolAd:string;
UstKod?:number;

constructor(item?:any){
this.AktifEh=item?.AktifEh||'';
this.BelediyeKod=item?.BelediyeKod||0;
this.BirimKod=item?.BirimKod;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.KadroAdet=item?.KadroAdet;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.RolAciklama=item?.RolAciklama||'';
this.RolAd=item?.RolAd||'';
this.UstKod=item?.UstKod;
}
}

export class BysGenModul {
Ad:string;
DegisKullaniciKod?:number;
DegisTarih?:Date;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
ModulUzantisi?:string;
Tur:string;

constructor(item?:any){
this.Ad=item?.Ad||'';
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.ModulUzantisi=item?.ModulUzantisi;
this.Tur=item?.Tur||'';
}
}

export class BysEksParametre {
ArsivEh:string;
BelediyeKod:number;
BelgeRootPath?:string;
BirimKod?:number;
CalismaPath?:string;
CevapBelgeTuruKod?:number;
CevapDosyaPlanKod?:string;
CevapIcerik?:string;
DegisKullaniciKod?:number;
DegisTarih?:Date;
DosyaPlanKod?:string;
DysServisAdres?:string;
DysTuru?:string;
EImzaEh?:string;
KayitKullaniciKod:number;
KayitTarih:Date;
KelimeIslemci?:string;
Kod:number;
MevzuatLink?:string;
ModulKod:number;
RaporBaslik1?:string;
RaporBaslik2?:string;
RaporBaslik3?:string;
RaporBaslik4?:string;
SablonDysId?:string;
SiniflandirmaTuru?:string;
SurecKod?:number;

constructor(item?:any){
this.ArsivEh=item?.ArsivEh||'';
this.BelediyeKod=item?.BelediyeKod||0;
this.BelgeRootPath=item?.BelgeRootPath;
this.BirimKod=item?.BirimKod;
this.CalismaPath=item?.CalismaPath;
this.CevapBelgeTuruKod=item?.CevapBelgeTuruKod;
this.CevapDosyaPlanKod=item?.CevapDosyaPlanKod;
this.CevapIcerik=item?.CevapIcerik;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.DosyaPlanKod=item?.DosyaPlanKod;
this.DysServisAdres=item?.DysServisAdres;
this.DysTuru=item?.DysTuru;
this.EImzaEh=item?.EImzaEh;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.KelimeIslemci=item?.KelimeIslemci;
this.Kod=item?.Kod||0;
this.MevzuatLink=item?.MevzuatLink;
this.ModulKod=item?.ModulKod||0;
this.RaporBaslik1=item?.RaporBaslik1;
this.RaporBaslik2=item?.RaporBaslik2;
this.RaporBaslik3=item?.RaporBaslik3;
this.RaporBaslik4=item?.RaporBaslik4;
this.SablonDysId=item?.SablonDysId;
this.SiniflandirmaTuru=item?.SiniflandirmaTuru;
this.SurecKod=item?.SurecKod;
}
}

export class BysGysIcraYazismaTur {
Ad:string;
BelediyeKod:number;
DagitimBirimKod?:number;
DegisKullaniciKod?:number;
DegisTarih?:Date;
HacizKalDagitimSekli:string;
HacizKalDosyaPlanKod?:string;
HacizKoyDagitimSekli:string;
HacizKoyDosyaPlanKod?:string;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
SurecKod?:number;
YaziBaslik?:string;
YaziBaslik1?:string;

constructor(item?:any){
this.Ad=item?.Ad||'';
this.BelediyeKod=item?.BelediyeKod||0;
this.DagitimBirimKod=item?.DagitimBirimKod;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.HacizKalDagitimSekli=item?.HacizKalDagitimSekli||'';
this.HacizKalDosyaPlanKod=item?.HacizKalDosyaPlanKod;
this.HacizKoyDagitimSekli=item?.HacizKoyDagitimSekli||'';
this.HacizKoyDosyaPlanKod=item?.HacizKoyDosyaPlanKod;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.SurecKod=item?.SurecKod;
this.YaziBaslik=item?.YaziBaslik;
this.YaziBaslik1=item?.YaziBaslik1;
}
}

export class BysMksParametre {
ArsivEh:string;
BelediyeKod:number;
BelgeRootPath?:string;
BirimKod?:number;
CalismaPath?:string;
DegisKullaniciKod?:number;
DegisTarih?:Date;
DosyaPlanKod?:string;
DysServisAdres?:string;
DysTuru?:string;
EImzaEh?:string;
KayitKullaniciKod:number;
KayitTarih:Date;
KelimeIslemci?:string;
Kod:number;
MevzuatLink?:string;
ModulKod:number;
RaporBaslik1?:string;
RaporBaslik2?:string;
RaporBaslik3?:string;
RaporBaslik4?:string;
SablonDysId?:string;
SiniflandirmaTuru?:string;
SurecKod?:number;

constructor(item?:any){
this.ArsivEh=item?.ArsivEh||'';
this.BelediyeKod=item?.BelediyeKod||0;
this.BelgeRootPath=item?.BelgeRootPath;
this.BirimKod=item?.BirimKod;
this.CalismaPath=item?.CalismaPath;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.DosyaPlanKod=item?.DosyaPlanKod;
this.DysServisAdres=item?.DysServisAdres;
this.DysTuru=item?.DysTuru;
this.EImzaEh=item?.EImzaEh;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.KelimeIslemci=item?.KelimeIslemci;
this.Kod=item?.Kod||0;
this.MevzuatLink=item?.MevzuatLink;
this.ModulKod=item?.ModulKod||0;
this.RaporBaslik1=item?.RaporBaslik1;
this.RaporBaslik2=item?.RaporBaslik2;
this.RaporBaslik3=item?.RaporBaslik3;
this.RaporBaslik4=item?.RaporBaslik4;
this.SablonDysId=item?.SablonDysId;
this.SiniflandirmaTuru=item?.SiniflandirmaTuru;
this.SurecKod=item?.SurecKod;
}
}

export class BysYisParametre {
ArsivEh:string;
BelediyeKod?:number;
BelgeRootPath?:string;
BirimKod?:number;
CalismaPath?:string;
CevapBelgeTuruKod?:number;
CevapDosyaPlanKod?:string;
CevapIcerik?:string;
DegisKullaniciKod?:number;
DegisTarih?:Date;
DosyaPlanKod?:string;
DysServisAdres?:string;
DysTuru?:string;
EImzaEh?:string;
GrupTurKod?:number;
KayitKullaniciKod:number;
KayitTarih:Date;
Kod:number;
MevzuatLink?:string;
RaporBaslik1?:string;
RaporBaslik2?:string;
RaporBaslik3?:string;
RaporBaslik4?:string;
SablonDysId?:string;
SiniflandirmaTuru?:string;
SurecKod?:number;

constructor(item?:any){
this.ArsivEh=item?.ArsivEh||'';
this.BelediyeKod=item?.BelediyeKod;
this.BelgeRootPath=item?.BelgeRootPath;
this.BirimKod=item?.BirimKod;
this.CalismaPath=item?.CalismaPath;
this.CevapBelgeTuruKod=item?.CevapBelgeTuruKod;
this.CevapDosyaPlanKod=item?.CevapDosyaPlanKod;
this.CevapIcerik=item?.CevapIcerik;
this.DegisKullaniciKod=item?.DegisKullaniciKod;
this.DegisTarih=item?.DegisTarih;
this.DosyaPlanKod=item?.DosyaPlanKod;
this.DysServisAdres=item?.DysServisAdres;
this.DysTuru=item?.DysTuru;
this.EImzaEh=item?.EImzaEh;
this.GrupTurKod=item?.GrupTurKod;
this.KayitKullaniciKod=item?.KayitKullaniciKod||0;
this.KayitTarih=item?.KayitTarih||new Date();
this.Kod=item?.Kod||0;
this.MevzuatLink=item?.MevzuatLink;
this.RaporBaslik1=item?.RaporBaslik1;
this.RaporBaslik2=item?.RaporBaslik2;
this.RaporBaslik3=item?.RaporBaslik3;
this.RaporBaslik4=item?.RaporBaslik4;
this.SablonDysId=item?.SablonDysId;
this.SiniflandirmaTuru=item?.SiniflandirmaTuru;
this.SurecKod=item?.SurecKod;
}
}
